/* tslint:disable */
/* eslint-disable */
/**
 * Radianse Member Import API - .Net 6
 * <b>Build:</b>Radianse.App.MemberImport CI_main_2024.1.30.1
 *
 * The version of the OpenAPI document: UserApi_V1
 * Contact: support@radianse.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { Configuration } from "./configuration";
import type { AxiosPromise, AxiosInstance, AxiosRequestConfig } from "axios";
import globalAxios from "axios";
// Some imports not used depending on template conditions
// @ts-ignore
import {
  DUMMY_BASE_URL,
  assertParamExists,
  setApiKeyToObject,
  setBasicAuthToObject,
  setBearerAuthToObject,
  setOAuthToObject,
  setSearchParams,
  serializeDataIfNeeded,
  toPathString,
  createRequestFunction,
} from "./common";
import type { RequestArgs } from "./base";
// @ts-ignore
import {
  BASE_PATH,
  COLLECTION_FORMATS,
  BaseAPI,
  RequiredError,
  operationServerMap,
} from "./base";

/**
 *
 * @export
 * @enum {string}
 */

export const IAddressType = {
  Unknown: "Unknown",
  Home: "Home",
  Work: "Work",
  Other: "Other",
} as const;

export type IAddressType = (typeof IAddressType)[keyof typeof IAddressType];

/**
 * Contains information about the Connector associated with the Equipment.
 * @export
 * @interface IConnectorInfo
 */
export interface IConnectorInfo {
  /**
   * The connector id.
   * @type {string}
   * @memberof IConnectorInfo
   */
  id?: string;
  /**
   * List of options the UI might need when working with the Connector.  This also contains the name for the device Id.
   * @type {{ [key: string]: any; }}
   * @memberof IConnectorInfo
   */
  options?: { [key: string]: any };
}
/**
 * The credentials used to connect to third party member import
 * @export
 * @interface ICredentialsInfo
 */
export interface ICredentialsInfo {
  /**
   * Name
   * @type {string}
   * @memberof ICredentialsInfo
   */
  importCredentialsName?: string;
  /**
   * Name
   * @type {string}
   * @memberof ICredentialsInfo
   */
  description?: string;
}
/**
 *
 * @export
 * @enum {string}
 */

export const IGenderType = {
  None: "None",
  Male: "Male",
  Female: "Female",
  Other: "Other",
  Unknown: "Unknown",
} as const;

export type IGenderType = (typeof IGenderType)[keyof typeof IGenderType];

/**
 *
 * @export
 * @interface IIRadianseRequestContext
 */
export interface IIRadianseRequestContext {
  /**
   *
   * @type {string}
   * @memberof IIRadianseRequestContext
   */
  clientAccessToken?: string;
  /**
   *
   * @type {string}
   * @memberof IIRadianseRequestContext
   */
  acceptLanguage?: string | null;
  /**
   *
   * @type {string}
   * @memberof IIRadianseRequestContext
   */
  ipAddress?: string;
  /**
   *
   * @type {boolean}
   * @memberof IIRadianseRequestContext
   */
  isUserRequest?: boolean;
  /**
   *
   * @type {string}
   * @memberof IIRadianseRequestContext
   */
  scopeToCustomerId?: string;
  /**
   *
   * @type {string}
   * @memberof IIRadianseRequestContext
   */
  scopeToGroupId?: string | null;
  /**
   *
   * @type {string}
   * @memberof IIRadianseRequestContext
   */
  scopeToTenantId?: string | null;
  /**
   *
   * @type {string}
   * @memberof IIRadianseRequestContext
   */
  userAccessToken?: string;
  /**
   *
   * @type {string}
   * @memberof IIRadianseRequestContext
   */
  detail?: string | null;
  /**
   *
   * @type {string}
   * @memberof IIRadianseRequestContext
   */
  identityProfileId?: string;
  /**
   *
   * @type {Array<string>}
   * @memberof IIRadianseRequestContext
   */
  clientRoles?: Array<string>;
  /**
   *
   * @type {Array<string>}
   * @memberof IIRadianseRequestContext
   */
  customerRoles?: Array<string>;
  /**
   *
   * @type {Array<string>}
   * @memberof IIRadianseRequestContext
   */
  groupRoles?: Array<string>;
  /**
   *
   * @type {Array<string>}
   * @memberof IIRadianseRequestContext
   */
  tenantRoles?: Array<string>;
  /**
   *
   * @type {Array<string>}
   * @memberof IIRadianseRequestContext
   */
  customerPermissions?: Array<string> | null;
  /**
   *
   * @type {Array<string>}
   * @memberof IIRadianseRequestContext
   */
  groupPermissions?: Array<string> | null;
  /**
   *
   * @type {Array<string>}
   * @memberof IIRadianseRequestContext
   */
  tenantPermissions?: Array<string> | null;
}
/**
 * For planetfitness, the list of clubs to import.
 * @export
 * @interface IImportAccountNumberList
 */
export interface IImportAccountNumberList {
  /**
   * ID
   * @type {string}
   * @memberof IImportAccountNumberList
   */
  id?: string | null;
  /**
   * PartitionKey
   * @type {string}
   * @memberof IImportAccountNumberList
   */
  partitionKey?: string | null;
  /**
   *
   * @type {string}
   * @memberof IImportAccountNumberList
   */
  category?: string;
  /**
   *
   * @type {string}
   * @memberof IImportAccountNumberList
   */
  subCategory?: string;
  /**
   * Account numbers to import
   * @type {Array<string>}
   * @memberof IImportAccountNumberList
   */
  accountNumbers: Array<string>;
  /**
   *
   * @type {IImportType}
   * @memberof IImportAccountNumberList
   */
  importType: IImportType;
  /**
   * Deleted
   * @type {boolean}
   * @memberof IImportAccountNumberList
   */
  deleted?: boolean;
}

/**
 *
 * @export
 * @interface IImportAccountNumberListDto
 */
export interface IImportAccountNumberListDto {
  /**
   * Account numbers to import
   * @type {Array<string>}
   * @memberof IImportAccountNumberListDto
   */
  accountNumbers: Array<string>;
}
/**
 *
 * @export
 * @interface IImportAccountNumberListIRadianseResult
 */
export interface IImportAccountNumberListIRadianseResult {
  /**
   *
   * @type {number}
   * @memberof IImportAccountNumberListIRadianseResult
   */
  count?: number | null;
  /**
   *
   * @type {IImportAccountNumberList}
   * @memberof IImportAccountNumberListIRadianseResult
   */
  data?: IImportAccountNumberList;
  /**
   *
   * @type {string}
   * @memberof IImportAccountNumberListIRadianseResult
   */
  detail: string;
  /**
   *
   * @type {{ [key: string]: Array<string>; }}
   * @memberof IImportAccountNumberListIRadianseResult
   */
  errors?: { [key: string]: Array<string> } | null;
  /**
   *
   * @type {string}
   * @memberof IImportAccountNumberListIRadianseResult
   */
  instance?: string | null;
  /**
   *
   * @type {number}
   * @memberof IImportAccountNumberListIRadianseResult
   */
  status?: number;
  /**
   *
   * @type {boolean}
   * @memberof IImportAccountNumberListIRadianseResult
   */
  success?: boolean;
  /**
   *
   * @type {string}
   * @memberof IImportAccountNumberListIRadianseResult
   */
  title?: string;
  /**
   *
   * @type {string}
   * @memberof IImportAccountNumberListIRadianseResult
   */
  traceId?: string | null;
  /**
   *
   * @type {string}
   * @memberof IImportAccountNumberListIRadianseResult
   */
  type?: string | null;
  /**
   *
   * @type {string}
   * @memberof IImportAccountNumberListIRadianseResult
   */
  continuationToken?: string | null;
}
/**
 *
 * @export
 * @interface IImportAccountNumberListIRadianseResultSuccess
 */
export interface IImportAccountNumberListIRadianseResultSuccess {
  /**
   *
   * @type {number}
   * @memberof IImportAccountNumberListIRadianseResultSuccess
   */
  count?: number | null;
  /**
   *
   * @type {IImportAccountNumberList}
   * @memberof IImportAccountNumberListIRadianseResultSuccess
   */
  data: IImportAccountNumberList;
  /**
   *
   * @type {string}
   * @memberof IImportAccountNumberListIRadianseResultSuccess
   */
  detail: string;
  /**
   *
   * @type {{ [key: string]: Array<string>; }}
   * @memberof IImportAccountNumberListIRadianseResultSuccess
   */
  errors?: { [key: string]: Array<string> } | null;
  /**
   *
   * @type {string}
   * @memberof IImportAccountNumberListIRadianseResultSuccess
   */
  instance?: string | null;
  /**
   *
   * @type {number}
   * @memberof IImportAccountNumberListIRadianseResultSuccess
   */
  status?: number;
  /**
   *
   * @type {boolean}
   * @memberof IImportAccountNumberListIRadianseResultSuccess
   */
  success?: boolean;
  /**
   *
   * @type {string}
   * @memberof IImportAccountNumberListIRadianseResultSuccess
   */
  title?: string;
  /**
   *
   * @type {string}
   * @memberof IImportAccountNumberListIRadianseResultSuccess
   */
  traceId?: string | null;
  /**
   *
   * @type {string}
   * @memberof IImportAccountNumberListIRadianseResultSuccess
   */
  type?: string | null;
  /**
   *
   * @type {string}
   * @memberof IImportAccountNumberListIRadianseResultSuccess
   */
  continuationToken?: string | null;
}
/**
 * Companies used to import members
 * @export
 * @enum {string}
 */

export const IImportType = {
  Abc: "ABC",
} as const;

export type IImportType = (typeof IImportType)[keyof typeof IImportType];

/**
 * Import type and credentials
 * @export
 * @interface IImportTypeCredentials
 */
export interface IImportTypeCredentials {
  /**
   * ID
   * @type {string}
   * @memberof IImportTypeCredentials
   */
  id?: string | null;
  /**
   *
   * @type {string}
   * @memberof IImportTypeCredentials
   */
  partitionKey?: string | null;
  /**
   *
   * @type {string}
   * @memberof IImportTypeCredentials
   */
  category?: string;
  /**
   *
   * @type {string}
   * @memberof IImportTypeCredentials
   */
  subCategory?: string;
  /**
   * Name
   * @type {string}
   * @memberof IImportTypeCredentials
   */
  name?: string;
  /**
   *
   * @type {IImportType}
   * @memberof IImportTypeCredentials
   */
  importType?: IImportType;
  /**
   * The credentials used to connect to third party member import
   * @type {Array<ICredentialsInfo>}
   * @memberof IImportTypeCredentials
   */
  credentials?: Array<ICredentialsInfo>;
  /**
   * Deleted
   * @type {boolean}
   * @memberof IImportTypeCredentials
   */
  deleted?: boolean;
}

/**
 *
 * @export
 * @interface IImportTypeCredentialsDto
 */
export interface IImportTypeCredentialsDto {
  /**
   * Name
   * @type {string}
   * @memberof IImportTypeCredentialsDto
   */
  name?: string;
  /**
   *
   * @type {IImportType}
   * @memberof IImportTypeCredentialsDto
   */
  importType?: IImportType;
  /**
   * The credentials used to connect to third party member import
   * @type {Array<ICredentialsInfo>}
   * @memberof IImportTypeCredentialsDto
   */
  credentials?: Array<ICredentialsInfo>;
}

/**
 *
 * @export
 * @interface IImportTypeCredentialsIRadianseResult
 */
export interface IImportTypeCredentialsIRadianseResult {
  /**
   *
   * @type {number}
   * @memberof IImportTypeCredentialsIRadianseResult
   */
  count?: number | null;
  /**
   *
   * @type {IImportTypeCredentials}
   * @memberof IImportTypeCredentialsIRadianseResult
   */
  data?: IImportTypeCredentials;
  /**
   *
   * @type {string}
   * @memberof IImportTypeCredentialsIRadianseResult
   */
  detail: string;
  /**
   *
   * @type {{ [key: string]: Array<string>; }}
   * @memberof IImportTypeCredentialsIRadianseResult
   */
  errors?: { [key: string]: Array<string> } | null;
  /**
   *
   * @type {string}
   * @memberof IImportTypeCredentialsIRadianseResult
   */
  instance?: string | null;
  /**
   *
   * @type {number}
   * @memberof IImportTypeCredentialsIRadianseResult
   */
  status?: number;
  /**
   *
   * @type {boolean}
   * @memberof IImportTypeCredentialsIRadianseResult
   */
  success?: boolean;
  /**
   *
   * @type {string}
   * @memberof IImportTypeCredentialsIRadianseResult
   */
  title?: string;
  /**
   *
   * @type {string}
   * @memberof IImportTypeCredentialsIRadianseResult
   */
  traceId?: string | null;
  /**
   *
   * @type {string}
   * @memberof IImportTypeCredentialsIRadianseResult
   */
  type?: string | null;
  /**
   *
   * @type {string}
   * @memberof IImportTypeCredentialsIRadianseResult
   */
  continuationToken?: string | null;
}
/**
 *
 * @export
 * @interface IImportTypeCredentialsIRadianseResultSuccess
 */
export interface IImportTypeCredentialsIRadianseResultSuccess {
  /**
   *
   * @type {number}
   * @memberof IImportTypeCredentialsIRadianseResultSuccess
   */
  count?: number | null;
  /**
   *
   * @type {IImportTypeCredentials}
   * @memberof IImportTypeCredentialsIRadianseResultSuccess
   */
  data: IImportTypeCredentials;
  /**
   *
   * @type {string}
   * @memberof IImportTypeCredentialsIRadianseResultSuccess
   */
  detail: string;
  /**
   *
   * @type {{ [key: string]: Array<string>; }}
   * @memberof IImportTypeCredentialsIRadianseResultSuccess
   */
  errors?: { [key: string]: Array<string> } | null;
  /**
   *
   * @type {string}
   * @memberof IImportTypeCredentialsIRadianseResultSuccess
   */
  instance?: string | null;
  /**
   *
   * @type {number}
   * @memberof IImportTypeCredentialsIRadianseResultSuccess
   */
  status?: number;
  /**
   *
   * @type {boolean}
   * @memberof IImportTypeCredentialsIRadianseResultSuccess
   */
  success?: boolean;
  /**
   *
   * @type {string}
   * @memberof IImportTypeCredentialsIRadianseResultSuccess
   */
  title?: string;
  /**
   *
   * @type {string}
   * @memberof IImportTypeCredentialsIRadianseResultSuccess
   */
  traceId?: string | null;
  /**
   *
   * @type {string}
   * @memberof IImportTypeCredentialsIRadianseResultSuccess
   */
  type?: string | null;
  /**
   *
   * @type {string}
   * @memberof IImportTypeCredentialsIRadianseResultSuccess
   */
  continuationToken?: string | null;
}
/**
 *
 * @export
 * @interface IImportTypeCredentialsListIRadianseResult
 */
export interface IImportTypeCredentialsListIRadianseResult {
  /**
   *
   * @type {number}
   * @memberof IImportTypeCredentialsListIRadianseResult
   */
  count?: number | null;
  /**
   *
   * @type {Array<IImportTypeCredentials>}
   * @memberof IImportTypeCredentialsListIRadianseResult
   */
  data?: Array<IImportTypeCredentials> | null;
  /**
   *
   * @type {string}
   * @memberof IImportTypeCredentialsListIRadianseResult
   */
  detail: string;
  /**
   *
   * @type {{ [key: string]: Array<string>; }}
   * @memberof IImportTypeCredentialsListIRadianseResult
   */
  errors?: { [key: string]: Array<string> } | null;
  /**
   *
   * @type {string}
   * @memberof IImportTypeCredentialsListIRadianseResult
   */
  instance?: string | null;
  /**
   *
   * @type {number}
   * @memberof IImportTypeCredentialsListIRadianseResult
   */
  status?: number;
  /**
   *
   * @type {boolean}
   * @memberof IImportTypeCredentialsListIRadianseResult
   */
  success?: boolean;
  /**
   *
   * @type {string}
   * @memberof IImportTypeCredentialsListIRadianseResult
   */
  title?: string;
  /**
   *
   * @type {string}
   * @memberof IImportTypeCredentialsListIRadianseResult
   */
  traceId?: string | null;
  /**
   *
   * @type {string}
   * @memberof IImportTypeCredentialsListIRadianseResult
   */
  type?: string | null;
  /**
   *
   * @type {string}
   * @memberof IImportTypeCredentialsListIRadianseResult
   */
  continuationToken?: string | null;
}
/**
 *
 * @export
 * @interface IImportTypeCredentialsListIRadianseResultSuccess
 */
export interface IImportTypeCredentialsListIRadianseResultSuccess {
  /**
   *
   * @type {number}
   * @memberof IImportTypeCredentialsListIRadianseResultSuccess
   */
  count?: number | null;
  /**
   *
   * @type {Array<IImportTypeCredentials>}
   * @memberof IImportTypeCredentialsListIRadianseResultSuccess
   */
  data: Array<IImportTypeCredentials>;
  /**
   *
   * @type {string}
   * @memberof IImportTypeCredentialsListIRadianseResultSuccess
   */
  detail: string;
  /**
   *
   * @type {{ [key: string]: Array<string>; }}
   * @memberof IImportTypeCredentialsListIRadianseResultSuccess
   */
  errors?: { [key: string]: Array<string> } | null;
  /**
   *
   * @type {string}
   * @memberof IImportTypeCredentialsListIRadianseResultSuccess
   */
  instance?: string | null;
  /**
   *
   * @type {number}
   * @memberof IImportTypeCredentialsListIRadianseResultSuccess
   */
  status?: number;
  /**
   *
   * @type {boolean}
   * @memberof IImportTypeCredentialsListIRadianseResultSuccess
   */
  success?: boolean;
  /**
   *
   * @type {string}
   * @memberof IImportTypeCredentialsListIRadianseResultSuccess
   */
  title?: string;
  /**
   *
   * @type {string}
   * @memberof IImportTypeCredentialsListIRadianseResultSuccess
   */
  traceId?: string | null;
  /**
   *
   * @type {string}
   * @memberof IImportTypeCredentialsListIRadianseResultSuccess
   */
  type?: string | null;
  /**
   *
   * @type {string}
   * @memberof IImportTypeCredentialsListIRadianseResultSuccess
   */
  continuationToken?: string | null;
}
/**
 * A Member
 * @export
 * @interface IMember
 */
export interface IMember {
  /**
   *
   * @type {string}
   * @memberof IMember
   */
  id?: string | null;
  /**
   * PartitionKey - case insensitive
   * @type {string}
   * @memberof IMember
   */
  partitionKey?: string | null;
  /**
   *
   * @type {string}
   * @memberof IMember
   */
  name: string;
  /**
   *
   * @type {string}
   * @memberof IMember
   */
  birthDate?: string | null;
  /**
   *
   * @type {string}
   * @memberof IMember
   */
  firstName?: string | null;
  /**
   *
   * @type {IGenderType}
   * @memberof IMember
   */
  gender?: IGenderType;
  /**
   *
   * @type {string}
   * @memberof IMember
   */
  lastName: string;
  /**
   *
   * @type {string}
   * @memberof IMember
   */
  middleName?: string | null;
  /**
   *
   * @type {string}
   * @memberof IMember
   */
  salutation?: string | null;
  /**
   *
   * @type {string}
   * @memberof IMember
   */
  suffix?: string | null;
  /**
   *
   * @type {Array<IConnectorInfo>}
   * @memberof IMember
   */
  connectors?: Array<IConnectorInfo>;
  /**
   *
   * @type {boolean}
   * @memberof IMember
   */
  deleted?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof IMember
   */
  global?: boolean | null;
  /**
   *
   * @type {string}
   * @memberof IMember
   */
  email?: string | null;
  /**
   * Default Phone number
   * @type {string}
   * @memberof IMember
   */
  phoneNumber?: string | null;
  /**
   *
   * @type {string}
   * @memberof IMember
   */
  category?: string;
  /**
   *
   * @type {string}
   * @memberof IMember
   */
  subCategory?: string;
  /**
   *
   * @type {string}
   * @memberof IMember
   */
  barcode: string;
  /**
   *
   * @type {string}
   * @memberof IMember
   */
  clubCode: string;
  /**
   *
   * @type {boolean}
   * @memberof IMember
   */
  active: boolean;
  /**
   *
   * @type {IAddressType}
   * @memberof IMember
   */
  addressType?: IAddressType;
  /**
   *
   * @type {string}
   * @memberof IMember
   */
  street1?: string | null;
  /**
   *
   * @type {string}
   * @memberof IMember
   */
  street2?: string | null;
  /**
   *
   * @type {string}
   * @memberof IMember
   */
  city?: string | null;
  /**
   *
   * @type {string}
   * @memberof IMember
   */
  postalCode?: string | null;
  /**
   * SUBDIVISION CODE (ISO 3166-2). For example \"US-NH\"
   * @type {string}
   * @memberof IMember
   */
  subdivisionCode?: string | null;
  /**
   * Country code as specified by the ISO 3166. For example \"US\"
   * @type {string}
   * @memberof IMember
   */
  countryCode?: string | null;
  /**
   *
   * @type {string}
   * @memberof IMember
   */
  cellPhoneProvider?: string | null;
  /**
   *
   * @type {string}
   * @memberof IMember
   */
  agreementNumber: string;
  /**
   *
   * @type {boolean}
   * @memberof IMember
   */
  hasSuitableCredit?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof IMember
   */
  inGoodStanding: boolean;
  /**
   *
   * @type {string}
   * @memberof IMember
   */
  lastUpdate?: string;
  /**
   *
   * @type {string}
   * @memberof IMember
   */
  memberType: string;
  /**
   * Curently Guid of membership type from ABC
   * @type {string}
   * @memberof IMember
   */
  serviceAccessTypeId?: string;
  /**
   *
   * @type {Array<{ [key: string]: any; }>}
   * @memberof IMember
   */
  history?: Array<{ [key: string]: any }> | null;
  /**
   * Stores all text fields compiled together. For the benefit of Search mechanism
   * @type {string}
   * @memberof IMember
   */
  search?: string | null;
  /**
   * Stores all text fields compiled together. For the benefits of Search mechanism
   * @type {Array<string>}
   * @memberof IMember
   */
  searchW?: Array<string> | null;
}

/**
 *
 * @export
 * @interface IMemberListIRadianseResult
 */
export interface IMemberListIRadianseResult {
  /**
   *
   * @type {number}
   * @memberof IMemberListIRadianseResult
   */
  count?: number | null;
  /**
   *
   * @type {Array<IMember>}
   * @memberof IMemberListIRadianseResult
   */
  data?: Array<IMember> | null;
  /**
   *
   * @type {string}
   * @memberof IMemberListIRadianseResult
   */
  detail: string;
  /**
   *
   * @type {{ [key: string]: Array<string>; }}
   * @memberof IMemberListIRadianseResult
   */
  errors?: { [key: string]: Array<string> } | null;
  /**
   *
   * @type {string}
   * @memberof IMemberListIRadianseResult
   */
  instance?: string | null;
  /**
   *
   * @type {number}
   * @memberof IMemberListIRadianseResult
   */
  status?: number;
  /**
   *
   * @type {boolean}
   * @memberof IMemberListIRadianseResult
   */
  success?: boolean;
  /**
   *
   * @type {string}
   * @memberof IMemberListIRadianseResult
   */
  title?: string;
  /**
   *
   * @type {string}
   * @memberof IMemberListIRadianseResult
   */
  traceId?: string | null;
  /**
   *
   * @type {string}
   * @memberof IMemberListIRadianseResult
   */
  type?: string | null;
  /**
   *
   * @type {string}
   * @memberof IMemberListIRadianseResult
   */
  continuationToken?: string | null;
}
/**
 *
 * @export
 * @interface IMemberListIRadianseResultSuccess
 */
export interface IMemberListIRadianseResultSuccess {
  /**
   *
   * @type {number}
   * @memberof IMemberListIRadianseResultSuccess
   */
  count?: number | null;
  /**
   *
   * @type {Array<IMember>}
   * @memberof IMemberListIRadianseResultSuccess
   */
  data: Array<IMember>;
  /**
   *
   * @type {string}
   * @memberof IMemberListIRadianseResultSuccess
   */
  detail: string;
  /**
   *
   * @type {{ [key: string]: Array<string>; }}
   * @memberof IMemberListIRadianseResultSuccess
   */
  errors?: { [key: string]: Array<string> } | null;
  /**
   *
   * @type {string}
   * @memberof IMemberListIRadianseResultSuccess
   */
  instance?: string | null;
  /**
   *
   * @type {number}
   * @memberof IMemberListIRadianseResultSuccess
   */
  status?: number;
  /**
   *
   * @type {boolean}
   * @memberof IMemberListIRadianseResultSuccess
   */
  success?: boolean;
  /**
   *
   * @type {string}
   * @memberof IMemberListIRadianseResultSuccess
   */
  title?: string;
  /**
   *
   * @type {string}
   * @memberof IMemberListIRadianseResultSuccess
   */
  traceId?: string | null;
  /**
   *
   * @type {string}
   * @memberof IMemberListIRadianseResultSuccess
   */
  type?: string | null;
  /**
   *
   * @type {string}
   * @memberof IMemberListIRadianseResultSuccess
   */
  continuationToken?: string | null;
}
/**
 *
 * @export
 * @interface IMemberUpdateReturn
 */
export interface IMemberUpdateReturn {
  /**
   *
   * @type {number}
   * @memberof IMemberUpdateReturn
   */
  processedCount?: number;
  /**
   *
   * @type {number}
   * @memberof IMemberUpdateReturn
   */
  updatedCount?: number;
  /**
   *
   * @type {string}
   * @memberof IMemberUpdateReturn
   */
  endPoint?: string;
  /**
   *
   * @type {string}
   * @memberof IMemberUpdateReturn
   */
  accountNumber?: string;
}
/**
 *
 * @export
 * @interface IMemberUpdateReturnIRadianseResult
 */
export interface IMemberUpdateReturnIRadianseResult {
  /**
   *
   * @type {number}
   * @memberof IMemberUpdateReturnIRadianseResult
   */
  count?: number | null;
  /**
   *
   * @type {IMemberUpdateReturn}
   * @memberof IMemberUpdateReturnIRadianseResult
   */
  data?: IMemberUpdateReturn;
  /**
   *
   * @type {string}
   * @memberof IMemberUpdateReturnIRadianseResult
   */
  detail: string;
  /**
   *
   * @type {{ [key: string]: Array<string>; }}
   * @memberof IMemberUpdateReturnIRadianseResult
   */
  errors?: { [key: string]: Array<string> } | null;
  /**
   *
   * @type {string}
   * @memberof IMemberUpdateReturnIRadianseResult
   */
  instance?: string | null;
  /**
   *
   * @type {number}
   * @memberof IMemberUpdateReturnIRadianseResult
   */
  status?: number;
  /**
   *
   * @type {boolean}
   * @memberof IMemberUpdateReturnIRadianseResult
   */
  success?: boolean;
  /**
   *
   * @type {string}
   * @memberof IMemberUpdateReturnIRadianseResult
   */
  title?: string;
  /**
   *
   * @type {string}
   * @memberof IMemberUpdateReturnIRadianseResult
   */
  traceId?: string | null;
  /**
   *
   * @type {string}
   * @memberof IMemberUpdateReturnIRadianseResult
   */
  type?: string | null;
  /**
   *
   * @type {string}
   * @memberof IMemberUpdateReturnIRadianseResult
   */
  continuationToken?: string | null;
}
/**
 *
 * @export
 * @interface IMemberUpdateReturnIRadianseResultSuccess
 */
export interface IMemberUpdateReturnIRadianseResultSuccess {
  /**
   *
   * @type {number}
   * @memberof IMemberUpdateReturnIRadianseResultSuccess
   */
  count?: number | null;
  /**
   *
   * @type {IMemberUpdateReturn}
   * @memberof IMemberUpdateReturnIRadianseResultSuccess
   */
  data: IMemberUpdateReturn;
  /**
   *
   * @type {string}
   * @memberof IMemberUpdateReturnIRadianseResultSuccess
   */
  detail: string;
  /**
   *
   * @type {{ [key: string]: Array<string>; }}
   * @memberof IMemberUpdateReturnIRadianseResultSuccess
   */
  errors?: { [key: string]: Array<string> } | null;
  /**
   *
   * @type {string}
   * @memberof IMemberUpdateReturnIRadianseResultSuccess
   */
  instance?: string | null;
  /**
   *
   * @type {number}
   * @memberof IMemberUpdateReturnIRadianseResultSuccess
   */
  status?: number;
  /**
   *
   * @type {boolean}
   * @memberof IMemberUpdateReturnIRadianseResultSuccess
   */
  success?: boolean;
  /**
   *
   * @type {string}
   * @memberof IMemberUpdateReturnIRadianseResultSuccess
   */
  title?: string;
  /**
   *
   * @type {string}
   * @memberof IMemberUpdateReturnIRadianseResultSuccess
   */
  traceId?: string | null;
  /**
   *
   * @type {string}
   * @memberof IMemberUpdateReturnIRadianseResultSuccess
   */
  type?: string | null;
  /**
   *
   * @type {string}
   * @memberof IMemberUpdateReturnIRadianseResultSuccess
   */
  continuationToken?: string | null;
}

/**
 * AccountNumberListApi - axios parameter creator
 * @export
 */
export const AccountNumberListApiAxiosParamCreator = function (
  configuration?: Configuration
) {
  return {
    /**
     * For ABC, these are in the /membershiptypes
     * @summary Get status of member import by account number (club code)
     * @param {IImportType} importType
     * @param {string} [accountNumber] For planet fitness, this is the club code.
     * @param {string} [groupId]
     * @param {string} [tenantId]
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiAccountNumberListCheckPointImportTypeGet: async (
      importType: IImportType,
      accountNumber?: string,
      groupId?: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'importType' is not null or undefined
      assertParamExists(
        "userApiAccountNumberListCheckPointImportTypeGet",
        "importType",
        importType
      );
      const localVarPath =
        `/UserApi/AccountNumberList/CheckPoint/{importType}`.replace(
          `{${"importType"}}`,
          encodeURIComponent(String(importType))
        );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "Authorization",
        configuration
      );

      if (accountNumber !== undefined) {
        localVarQueryParameter["accountNumber"] = accountNumber;
      }

      if (groupId !== undefined) {
        localVarQueryParameter["groupId"] = groupId;
      }

      if (tenantId !== undefined) {
        localVarQueryParameter["tenantId"] = tenantId;
      }

      if (apiVersion !== undefined) {
        localVarQueryParameter["api-version"] = apiVersion;
      }

      if (acceptLanguage != null) {
        localVarHeaderParameter["Accept-Language"] = String(acceptLanguage);
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Permission: accountnumberlist_delete
     * @summary Delete an account number
     * @param {IImportType} importType
     * @param {string} accountNumber
     * @param {string} [groupId]
     * @param {string} [tenantId]
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiAccountNumberListImportTypeAccountNumberAccountNumberDelete: async (
      importType: IImportType,
      accountNumber: string,
      groupId?: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'importType' is not null or undefined
      assertParamExists(
        "userApiAccountNumberListImportTypeAccountNumberAccountNumberDelete",
        "importType",
        importType
      );
      // verify required parameter 'accountNumber' is not null or undefined
      assertParamExists(
        "userApiAccountNumberListImportTypeAccountNumberAccountNumberDelete",
        "accountNumber",
        accountNumber
      );
      const localVarPath =
        `/UserApi/AccountNumberList/{importType}/AccountNumber/{accountNumber}`
          .replace(`{${"importType"}}`, encodeURIComponent(String(importType)))
          .replace(
            `{${"accountNumber"}}`,
            encodeURIComponent(String(accountNumber))
          );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "DELETE",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "Authorization",
        configuration
      );

      if (groupId !== undefined) {
        localVarQueryParameter["groupId"] = groupId;
      }

      if (tenantId !== undefined) {
        localVarQueryParameter["tenantId"] = tenantId;
      }

      if (apiVersion !== undefined) {
        localVarQueryParameter["api-version"] = apiVersion;
      }

      if (acceptLanguage != null) {
        localVarHeaderParameter["Accept-Language"] = String(acceptLanguage);
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Permission: accountnumberlist_create
     * @summary Add an account number to the existing list of account numbers
     * @param {IImportType} importType
     * @param {string} accountNumber
     * @param {string} [groupId] If using a group token, include groupId
     * @param {string} [tenantId] If using a tenant token, include tenantId
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiAccountNumberListImportTypeAccountNumberAccountNumberPut: async (
      importType: IImportType,
      accountNumber: string,
      groupId?: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'importType' is not null or undefined
      assertParamExists(
        "userApiAccountNumberListImportTypeAccountNumberAccountNumberPut",
        "importType",
        importType
      );
      // verify required parameter 'accountNumber' is not null or undefined
      assertParamExists(
        "userApiAccountNumberListImportTypeAccountNumberAccountNumberPut",
        "accountNumber",
        accountNumber
      );
      const localVarPath =
        `/UserApi/AccountNumberList/{importType}/AccountNumber/{accountNumber}`
          .replace(`{${"importType"}}`, encodeURIComponent(String(importType)))
          .replace(
            `{${"accountNumber"}}`,
            encodeURIComponent(String(accountNumber))
          );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "PUT",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "Authorization",
        configuration
      );

      if (groupId !== undefined) {
        localVarQueryParameter["groupId"] = groupId;
      }

      if (tenantId !== undefined) {
        localVarQueryParameter["tenantId"] = tenantId;
      }

      if (apiVersion !== undefined) {
        localVarQueryParameter["api-version"] = apiVersion;
      }

      if (acceptLanguage != null) {
        localVarHeaderParameter["Accept-Language"] = String(acceptLanguage);
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Permission: accountnumberlist_delete
     * @summary Delete the account numbers
     * @param {IImportType} importType
     * @param {string} [groupId] If using a group token, include groupId
     * @param {string} [tenantId] If using a tenant token, include tenantId
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiAccountNumberListImportTypeDelete: async (
      importType: IImportType,
      groupId?: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'importType' is not null or undefined
      assertParamExists(
        "userApiAccountNumberListImportTypeDelete",
        "importType",
        importType
      );
      const localVarPath = `/UserApi/AccountNumberList/{importType}`.replace(
        `{${"importType"}}`,
        encodeURIComponent(String(importType))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "DELETE",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "Authorization",
        configuration
      );

      if (groupId !== undefined) {
        localVarQueryParameter["groupId"] = groupId;
      }

      if (tenantId !== undefined) {
        localVarQueryParameter["tenantId"] = tenantId;
      }

      if (apiVersion !== undefined) {
        localVarQueryParameter["api-version"] = apiVersion;
      }

      if (acceptLanguage != null) {
        localVarHeaderParameter["Accept-Language"] = String(acceptLanguage);
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Permission: accountnumberlist_read
     * @summary Get account number to import by type of company to import from.
     * @param {IImportType} importType
     * @param {string} [groupId] If using a group token, include groupId
     * @param {string} [tenantId] If using a tenant token, include tenantId
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiAccountNumberListImportTypeGet: async (
      importType: IImportType,
      groupId?: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'importType' is not null or undefined
      assertParamExists(
        "userApiAccountNumberListImportTypeGet",
        "importType",
        importType
      );
      const localVarPath = `/UserApi/AccountNumberList/{importType}`.replace(
        `{${"importType"}}`,
        encodeURIComponent(String(importType))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "Authorization",
        configuration
      );

      if (groupId !== undefined) {
        localVarQueryParameter["groupId"] = groupId;
      }

      if (tenantId !== undefined) {
        localVarQueryParameter["tenantId"] = tenantId;
      }

      if (apiVersion !== undefined) {
        localVarQueryParameter["api-version"] = apiVersion;
      }

      if (acceptLanguage != null) {
        localVarHeaderParameter["Accept-Language"] = String(acceptLanguage);
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Permission: accountnumberlist_create
     * @summary Put account numbers to import
     * @param {IImportType} importType
     * @param {string} [groupId] If using a group token, include groupId
     * @param {string} [tenantId] If using a tenant token, include tenantId
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {IImportAccountNumberListDto} [iImportAccountNumberListDto]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiAccountNumberListImportTypePut: async (
      importType: IImportType,
      groupId?: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      iImportAccountNumberListDto?: IImportAccountNumberListDto,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'importType' is not null or undefined
      assertParamExists(
        "userApiAccountNumberListImportTypePut",
        "importType",
        importType
      );
      const localVarPath = `/UserApi/AccountNumberList/{importType}`.replace(
        `{${"importType"}}`,
        encodeURIComponent(String(importType))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "PUT",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "Authorization",
        configuration
      );

      if (groupId !== undefined) {
        localVarQueryParameter["groupId"] = groupId;
      }

      if (tenantId !== undefined) {
        localVarQueryParameter["tenantId"] = tenantId;
      }

      if (apiVersion !== undefined) {
        localVarQueryParameter["api-version"] = apiVersion;
      }

      if (acceptLanguage != null) {
        localVarHeaderParameter["Accept-Language"] = String(acceptLanguage);
      }

      localVarHeaderParameter["Content-Type"] = "application/json-patch+json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        iImportAccountNumberListDto,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * For ABC, these are in the /membershiptypes
     * @summary Get status of member import by account number (club code)
     * @param {IImportType} importType
     * @param {string} [accountNumber] For planet fitness, this is the club code.
     * @param {string} [groupId]
     * @param {string} [tenantId]
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiV1AccountNumberListCheckPointImportTypeGet: async (
      importType: IImportType,
      accountNumber?: string,
      groupId?: string,
      tenantId?: string,
      acceptLanguage?: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'importType' is not null or undefined
      assertParamExists(
        "userApiV1AccountNumberListCheckPointImportTypeGet",
        "importType",
        importType
      );
      const localVarPath =
        `/UserApi/v1/AccountNumberList/CheckPoint/{importType}`.replace(
          `{${"importType"}}`,
          encodeURIComponent(String(importType))
        );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "Authorization",
        configuration
      );

      if (accountNumber !== undefined) {
        localVarQueryParameter["accountNumber"] = accountNumber;
      }

      if (groupId !== undefined) {
        localVarQueryParameter["groupId"] = groupId;
      }

      if (tenantId !== undefined) {
        localVarQueryParameter["tenantId"] = tenantId;
      }

      if (acceptLanguage != null) {
        localVarHeaderParameter["Accept-Language"] = String(acceptLanguage);
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Permission: accountnumberlist_delete
     * @summary Delete an account number
     * @param {IImportType} importType
     * @param {string} accountNumber
     * @param {string} [groupId]
     * @param {string} [tenantId]
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiV1AccountNumberListImportTypeAccountNumberAccountNumberDelete:
      async (
        importType: IImportType,
        accountNumber: string,
        groupId?: string,
        tenantId?: string,
        acceptLanguage?: string,
        options: AxiosRequestConfig = {}
      ): Promise<RequestArgs> => {
        // verify required parameter 'importType' is not null or undefined
        assertParamExists(
          "userApiV1AccountNumberListImportTypeAccountNumberAccountNumberDelete",
          "importType",
          importType
        );
        // verify required parameter 'accountNumber' is not null or undefined
        assertParamExists(
          "userApiV1AccountNumberListImportTypeAccountNumberAccountNumberDelete",
          "accountNumber",
          accountNumber
        );
        const localVarPath =
          `/UserApi/v1/AccountNumberList/{importType}/AccountNumber/{accountNumber}`
            .replace(
              `{${"importType"}}`,
              encodeURIComponent(String(importType))
            )
            .replace(
              `{${"accountNumber"}}`,
              encodeURIComponent(String(accountNumber))
            );
        // use dummy base URL string because the URL constructor only accepts absolute URLs.
        const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
        let baseOptions;
        if (configuration) {
          baseOptions = configuration.baseOptions;
        }

        const localVarRequestOptions = {
          method: "DELETE",
          ...baseOptions,
          ...options,
        };
        const localVarHeaderParameter = {} as any;
        const localVarQueryParameter = {} as any;

        // authentication Bearer required
        await setApiKeyToObject(
          localVarHeaderParameter,
          "Authorization",
          configuration
        );

        if (groupId !== undefined) {
          localVarQueryParameter["groupId"] = groupId;
        }

        if (tenantId !== undefined) {
          localVarQueryParameter["tenantId"] = tenantId;
        }

        if (acceptLanguage != null) {
          localVarHeaderParameter["Accept-Language"] = String(acceptLanguage);
        }

        setSearchParams(localVarUrlObj, localVarQueryParameter);
        let headersFromBaseOptions =
          baseOptions && baseOptions.headers ? baseOptions.headers : {};
        localVarRequestOptions.headers = {
          ...localVarHeaderParameter,
          ...headersFromBaseOptions,
          ...options.headers,
        };

        return {
          url: toPathString(localVarUrlObj),
          options: localVarRequestOptions,
        };
      },
    /**
     * Permission: accountnumberlist_create
     * @summary Add an account number to the existing list of account numbers
     * @param {IImportType} importType
     * @param {string} accountNumber
     * @param {string} [groupId] If using a group token, include groupId
     * @param {string} [tenantId] If using a tenant token, include tenantId
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiV1AccountNumberListImportTypeAccountNumberAccountNumberPut: async (
      importType: IImportType,
      accountNumber: string,
      groupId?: string,
      tenantId?: string,
      acceptLanguage?: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'importType' is not null or undefined
      assertParamExists(
        "userApiV1AccountNumberListImportTypeAccountNumberAccountNumberPut",
        "importType",
        importType
      );
      // verify required parameter 'accountNumber' is not null or undefined
      assertParamExists(
        "userApiV1AccountNumberListImportTypeAccountNumberAccountNumberPut",
        "accountNumber",
        accountNumber
      );
      const localVarPath =
        `/UserApi/v1/AccountNumberList/{importType}/AccountNumber/{accountNumber}`
          .replace(`{${"importType"}}`, encodeURIComponent(String(importType)))
          .replace(
            `{${"accountNumber"}}`,
            encodeURIComponent(String(accountNumber))
          );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "PUT",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "Authorization",
        configuration
      );

      if (groupId !== undefined) {
        localVarQueryParameter["groupId"] = groupId;
      }

      if (tenantId !== undefined) {
        localVarQueryParameter["tenantId"] = tenantId;
      }

      if (acceptLanguage != null) {
        localVarHeaderParameter["Accept-Language"] = String(acceptLanguage);
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Permission: accountnumberlist_delete
     * @summary Delete the account numbers
     * @param {IImportType} importType
     * @param {string} [groupId] If using a group token, include groupId
     * @param {string} [tenantId] If using a tenant token, include tenantId
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiV1AccountNumberListImportTypeDelete: async (
      importType: IImportType,
      groupId?: string,
      tenantId?: string,
      acceptLanguage?: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'importType' is not null or undefined
      assertParamExists(
        "userApiV1AccountNumberListImportTypeDelete",
        "importType",
        importType
      );
      const localVarPath = `/UserApi/v1/AccountNumberList/{importType}`.replace(
        `{${"importType"}}`,
        encodeURIComponent(String(importType))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "DELETE",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "Authorization",
        configuration
      );

      if (groupId !== undefined) {
        localVarQueryParameter["groupId"] = groupId;
      }

      if (tenantId !== undefined) {
        localVarQueryParameter["tenantId"] = tenantId;
      }

      if (acceptLanguage != null) {
        localVarHeaderParameter["Accept-Language"] = String(acceptLanguage);
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Permission: accountnumberlist_read
     * @summary Get account number to import by type of company to import from.
     * @param {IImportType} importType
     * @param {string} [groupId] If using a group token, include groupId
     * @param {string} [tenantId] If using a tenant token, include tenantId
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiV1AccountNumberListImportTypeGet: async (
      importType: IImportType,
      groupId?: string,
      tenantId?: string,
      acceptLanguage?: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'importType' is not null or undefined
      assertParamExists(
        "userApiV1AccountNumberListImportTypeGet",
        "importType",
        importType
      );
      const localVarPath = `/UserApi/v1/AccountNumberList/{importType}`.replace(
        `{${"importType"}}`,
        encodeURIComponent(String(importType))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "Authorization",
        configuration
      );

      if (groupId !== undefined) {
        localVarQueryParameter["groupId"] = groupId;
      }

      if (tenantId !== undefined) {
        localVarQueryParameter["tenantId"] = tenantId;
      }

      if (acceptLanguage != null) {
        localVarHeaderParameter["Accept-Language"] = String(acceptLanguage);
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Permission: accountnumberlist_create
     * @summary Put account numbers to import
     * @param {IImportType} importType
     * @param {string} [groupId] If using a group token, include groupId
     * @param {string} [tenantId] If using a tenant token, include tenantId
     * @param {string} [acceptLanguage]
     * @param {IImportAccountNumberListDto} [iImportAccountNumberListDto]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiV1AccountNumberListImportTypePut: async (
      importType: IImportType,
      groupId?: string,
      tenantId?: string,
      acceptLanguage?: string,
      iImportAccountNumberListDto?: IImportAccountNumberListDto,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'importType' is not null or undefined
      assertParamExists(
        "userApiV1AccountNumberListImportTypePut",
        "importType",
        importType
      );
      const localVarPath = `/UserApi/v1/AccountNumberList/{importType}`.replace(
        `{${"importType"}}`,
        encodeURIComponent(String(importType))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "PUT",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "Authorization",
        configuration
      );

      if (groupId !== undefined) {
        localVarQueryParameter["groupId"] = groupId;
      }

      if (tenantId !== undefined) {
        localVarQueryParameter["tenantId"] = tenantId;
      }

      if (acceptLanguage != null) {
        localVarHeaderParameter["Accept-Language"] = String(acceptLanguage);
      }

      localVarHeaderParameter["Content-Type"] = "application/json-patch+json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        iImportAccountNumberListDto,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * AccountNumberListApi - functional programming interface
 * @export
 */
export const AccountNumberListApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator =
    AccountNumberListApiAxiosParamCreator(configuration);
  return {
    /**
     * For ABC, these are in the /membershiptypes
     * @summary Get status of member import by account number (club code)
     * @param {IImportType} importType
     * @param {string} [accountNumber] For planet fitness, this is the club code.
     * @param {string} [groupId]
     * @param {string} [tenantId]
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async userApiAccountNumberListCheckPointImportTypeGet(
      importType: IImportType,
      accountNumber?: string,
      groupId?: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<IMemberUpdateReturnIRadianseResultSuccess>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.userApiAccountNumberListCheckPointImportTypeGet(
          importType,
          accountNumber,
          groupId,
          tenantId,
          apiVersion,
          acceptLanguage,
          options
        );
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap[
          "AccountNumberListApi.userApiAccountNumberListCheckPointImportTypeGet"
        ]?.[index]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, operationBasePath || basePath);
    },
    /**
     * Permission: accountnumberlist_delete
     * @summary Delete an account number
     * @param {IImportType} importType
     * @param {string} accountNumber
     * @param {string} [groupId]
     * @param {string} [tenantId]
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async userApiAccountNumberListImportTypeAccountNumberAccountNumberDelete(
      importType: IImportType,
      accountNumber: string,
      groupId?: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<IImportAccountNumberListIRadianseResultSuccess>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.userApiAccountNumberListImportTypeAccountNumberAccountNumberDelete(
          importType,
          accountNumber,
          groupId,
          tenantId,
          apiVersion,
          acceptLanguage,
          options
        );
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap[
          "AccountNumberListApi.userApiAccountNumberListImportTypeAccountNumberAccountNumberDelete"
        ]?.[index]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, operationBasePath || basePath);
    },
    /**
     * Permission: accountnumberlist_create
     * @summary Add an account number to the existing list of account numbers
     * @param {IImportType} importType
     * @param {string} accountNumber
     * @param {string} [groupId] If using a group token, include groupId
     * @param {string} [tenantId] If using a tenant token, include tenantId
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async userApiAccountNumberListImportTypeAccountNumberAccountNumberPut(
      importType: IImportType,
      accountNumber: string,
      groupId?: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<IImportAccountNumberListIRadianseResultSuccess>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.userApiAccountNumberListImportTypeAccountNumberAccountNumberPut(
          importType,
          accountNumber,
          groupId,
          tenantId,
          apiVersion,
          acceptLanguage,
          options
        );
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap[
          "AccountNumberListApi.userApiAccountNumberListImportTypeAccountNumberAccountNumberPut"
        ]?.[index]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, operationBasePath || basePath);
    },
    /**
     * Permission: accountnumberlist_delete
     * @summary Delete the account numbers
     * @param {IImportType} importType
     * @param {string} [groupId] If using a group token, include groupId
     * @param {string} [tenantId] If using a tenant token, include tenantId
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async userApiAccountNumberListImportTypeDelete(
      importType: IImportType,
      groupId?: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<IImportAccountNumberListIRadianseResultSuccess>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.userApiAccountNumberListImportTypeDelete(
          importType,
          groupId,
          tenantId,
          apiVersion,
          acceptLanguage,
          options
        );
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap[
          "AccountNumberListApi.userApiAccountNumberListImportTypeDelete"
        ]?.[index]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, operationBasePath || basePath);
    },
    /**
     * Permission: accountnumberlist_read
     * @summary Get account number to import by type of company to import from.
     * @param {IImportType} importType
     * @param {string} [groupId] If using a group token, include groupId
     * @param {string} [tenantId] If using a tenant token, include tenantId
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async userApiAccountNumberListImportTypeGet(
      importType: IImportType,
      groupId?: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<IImportAccountNumberListIRadianseResultSuccess>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.userApiAccountNumberListImportTypeGet(
          importType,
          groupId,
          tenantId,
          apiVersion,
          acceptLanguage,
          options
        );
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap[
          "AccountNumberListApi.userApiAccountNumberListImportTypeGet"
        ]?.[index]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, operationBasePath || basePath);
    },
    /**
     * Permission: accountnumberlist_create
     * @summary Put account numbers to import
     * @param {IImportType} importType
     * @param {string} [groupId] If using a group token, include groupId
     * @param {string} [tenantId] If using a tenant token, include tenantId
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {IImportAccountNumberListDto} [iImportAccountNumberListDto]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async userApiAccountNumberListImportTypePut(
      importType: IImportType,
      groupId?: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      iImportAccountNumberListDto?: IImportAccountNumberListDto,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<IImportAccountNumberListIRadianseResultSuccess>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.userApiAccountNumberListImportTypePut(
          importType,
          groupId,
          tenantId,
          apiVersion,
          acceptLanguage,
          iImportAccountNumberListDto,
          options
        );
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap[
          "AccountNumberListApi.userApiAccountNumberListImportTypePut"
        ]?.[index]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, operationBasePath || basePath);
    },
    /**
     * For ABC, these are in the /membershiptypes
     * @summary Get status of member import by account number (club code)
     * @param {IImportType} importType
     * @param {string} [accountNumber] For planet fitness, this is the club code.
     * @param {string} [groupId]
     * @param {string} [tenantId]
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async userApiV1AccountNumberListCheckPointImportTypeGet(
      importType: IImportType,
      accountNumber?: string,
      groupId?: string,
      tenantId?: string,
      acceptLanguage?: string,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<IMemberUpdateReturnIRadianseResultSuccess>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.userApiV1AccountNumberListCheckPointImportTypeGet(
          importType,
          accountNumber,
          groupId,
          tenantId,
          acceptLanguage,
          options
        );
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap[
          "AccountNumberListApi.userApiV1AccountNumberListCheckPointImportTypeGet"
        ]?.[index]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, operationBasePath || basePath);
    },
    /**
     * Permission: accountnumberlist_delete
     * @summary Delete an account number
     * @param {IImportType} importType
     * @param {string} accountNumber
     * @param {string} [groupId]
     * @param {string} [tenantId]
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async userApiV1AccountNumberListImportTypeAccountNumberAccountNumberDelete(
      importType: IImportType,
      accountNumber: string,
      groupId?: string,
      tenantId?: string,
      acceptLanguage?: string,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<IImportAccountNumberListIRadianseResultSuccess>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.userApiV1AccountNumberListImportTypeAccountNumberAccountNumberDelete(
          importType,
          accountNumber,
          groupId,
          tenantId,
          acceptLanguage,
          options
        );
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap[
          "AccountNumberListApi.userApiV1AccountNumberListImportTypeAccountNumberAccountNumberDelete"
        ]?.[index]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, operationBasePath || basePath);
    },
    /**
     * Permission: accountnumberlist_create
     * @summary Add an account number to the existing list of account numbers
     * @param {IImportType} importType
     * @param {string} accountNumber
     * @param {string} [groupId] If using a group token, include groupId
     * @param {string} [tenantId] If using a tenant token, include tenantId
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async userApiV1AccountNumberListImportTypeAccountNumberAccountNumberPut(
      importType: IImportType,
      accountNumber: string,
      groupId?: string,
      tenantId?: string,
      acceptLanguage?: string,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<IImportAccountNumberListIRadianseResultSuccess>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.userApiV1AccountNumberListImportTypeAccountNumberAccountNumberPut(
          importType,
          accountNumber,
          groupId,
          tenantId,
          acceptLanguage,
          options
        );
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap[
          "AccountNumberListApi.userApiV1AccountNumberListImportTypeAccountNumberAccountNumberPut"
        ]?.[index]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, operationBasePath || basePath);
    },
    /**
     * Permission: accountnumberlist_delete
     * @summary Delete the account numbers
     * @param {IImportType} importType
     * @param {string} [groupId] If using a group token, include groupId
     * @param {string} [tenantId] If using a tenant token, include tenantId
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async userApiV1AccountNumberListImportTypeDelete(
      importType: IImportType,
      groupId?: string,
      tenantId?: string,
      acceptLanguage?: string,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<IImportAccountNumberListIRadianseResultSuccess>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.userApiV1AccountNumberListImportTypeDelete(
          importType,
          groupId,
          tenantId,
          acceptLanguage,
          options
        );
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap[
          "AccountNumberListApi.userApiV1AccountNumberListImportTypeDelete"
        ]?.[index]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, operationBasePath || basePath);
    },
    /**
     * Permission: accountnumberlist_read
     * @summary Get account number to import by type of company to import from.
     * @param {IImportType} importType
     * @param {string} [groupId] If using a group token, include groupId
     * @param {string} [tenantId] If using a tenant token, include tenantId
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async userApiV1AccountNumberListImportTypeGet(
      importType: IImportType,
      groupId?: string,
      tenantId?: string,
      acceptLanguage?: string,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<IImportAccountNumberListIRadianseResultSuccess>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.userApiV1AccountNumberListImportTypeGet(
          importType,
          groupId,
          tenantId,
          acceptLanguage,
          options
        );
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap[
          "AccountNumberListApi.userApiV1AccountNumberListImportTypeGet"
        ]?.[index]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, operationBasePath || basePath);
    },
    /**
     * Permission: accountnumberlist_create
     * @summary Put account numbers to import
     * @param {IImportType} importType
     * @param {string} [groupId] If using a group token, include groupId
     * @param {string} [tenantId] If using a tenant token, include tenantId
     * @param {string} [acceptLanguage]
     * @param {IImportAccountNumberListDto} [iImportAccountNumberListDto]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async userApiV1AccountNumberListImportTypePut(
      importType: IImportType,
      groupId?: string,
      tenantId?: string,
      acceptLanguage?: string,
      iImportAccountNumberListDto?: IImportAccountNumberListDto,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<IImportAccountNumberListIRadianseResultSuccess>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.userApiV1AccountNumberListImportTypePut(
          importType,
          groupId,
          tenantId,
          acceptLanguage,
          iImportAccountNumberListDto,
          options
        );
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap[
          "AccountNumberListApi.userApiV1AccountNumberListImportTypePut"
        ]?.[index]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, operationBasePath || basePath);
    },
  };
};

/**
 * AccountNumberListApi - factory interface
 * @export
 */
export const AccountNumberListApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = AccountNumberListApiFp(configuration);
  return {
    /**
     * For ABC, these are in the /membershiptypes
     * @summary Get status of member import by account number (club code)
     * @param {IImportType} importType
     * @param {string} [accountNumber] For planet fitness, this is the club code.
     * @param {string} [groupId]
     * @param {string} [tenantId]
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiAccountNumberListCheckPointImportTypeGet(
      importType: IImportType,
      accountNumber?: string,
      groupId?: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options?: any
    ): AxiosPromise<IMemberUpdateReturnIRadianseResultSuccess> {
      return localVarFp
        .userApiAccountNumberListCheckPointImportTypeGet(
          importType,
          accountNumber,
          groupId,
          tenantId,
          apiVersion,
          acceptLanguage,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     * Permission: accountnumberlist_delete
     * @summary Delete an account number
     * @param {IImportType} importType
     * @param {string} accountNumber
     * @param {string} [groupId]
     * @param {string} [tenantId]
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiAccountNumberListImportTypeAccountNumberAccountNumberDelete(
      importType: IImportType,
      accountNumber: string,
      groupId?: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options?: any
    ): AxiosPromise<IImportAccountNumberListIRadianseResultSuccess> {
      return localVarFp
        .userApiAccountNumberListImportTypeAccountNumberAccountNumberDelete(
          importType,
          accountNumber,
          groupId,
          tenantId,
          apiVersion,
          acceptLanguage,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     * Permission: accountnumberlist_create
     * @summary Add an account number to the existing list of account numbers
     * @param {IImportType} importType
     * @param {string} accountNumber
     * @param {string} [groupId] If using a group token, include groupId
     * @param {string} [tenantId] If using a tenant token, include tenantId
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiAccountNumberListImportTypeAccountNumberAccountNumberPut(
      importType: IImportType,
      accountNumber: string,
      groupId?: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options?: any
    ): AxiosPromise<IImportAccountNumberListIRadianseResultSuccess> {
      return localVarFp
        .userApiAccountNumberListImportTypeAccountNumberAccountNumberPut(
          importType,
          accountNumber,
          groupId,
          tenantId,
          apiVersion,
          acceptLanguage,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     * Permission: accountnumberlist_delete
     * @summary Delete the account numbers
     * @param {IImportType} importType
     * @param {string} [groupId] If using a group token, include groupId
     * @param {string} [tenantId] If using a tenant token, include tenantId
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiAccountNumberListImportTypeDelete(
      importType: IImportType,
      groupId?: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options?: any
    ): AxiosPromise<IImportAccountNumberListIRadianseResultSuccess> {
      return localVarFp
        .userApiAccountNumberListImportTypeDelete(
          importType,
          groupId,
          tenantId,
          apiVersion,
          acceptLanguage,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     * Permission: accountnumberlist_read
     * @summary Get account number to import by type of company to import from.
     * @param {IImportType} importType
     * @param {string} [groupId] If using a group token, include groupId
     * @param {string} [tenantId] If using a tenant token, include tenantId
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiAccountNumberListImportTypeGet(
      importType: IImportType,
      groupId?: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options?: any
    ): AxiosPromise<IImportAccountNumberListIRadianseResultSuccess> {
      return localVarFp
        .userApiAccountNumberListImportTypeGet(
          importType,
          groupId,
          tenantId,
          apiVersion,
          acceptLanguage,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     * Permission: accountnumberlist_create
     * @summary Put account numbers to import
     * @param {IImportType} importType
     * @param {string} [groupId] If using a group token, include groupId
     * @param {string} [tenantId] If using a tenant token, include tenantId
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {IImportAccountNumberListDto} [iImportAccountNumberListDto]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiAccountNumberListImportTypePut(
      importType: IImportType,
      groupId?: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      iImportAccountNumberListDto?: IImportAccountNumberListDto,
      options?: any
    ): AxiosPromise<IImportAccountNumberListIRadianseResultSuccess> {
      return localVarFp
        .userApiAccountNumberListImportTypePut(
          importType,
          groupId,
          tenantId,
          apiVersion,
          acceptLanguage,
          iImportAccountNumberListDto,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     * For ABC, these are in the /membershiptypes
     * @summary Get status of member import by account number (club code)
     * @param {IImportType} importType
     * @param {string} [accountNumber] For planet fitness, this is the club code.
     * @param {string} [groupId]
     * @param {string} [tenantId]
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiV1AccountNumberListCheckPointImportTypeGet(
      importType: IImportType,
      accountNumber?: string,
      groupId?: string,
      tenantId?: string,
      acceptLanguage?: string,
      options?: any
    ): AxiosPromise<IMemberUpdateReturnIRadianseResultSuccess> {
      return localVarFp
        .userApiV1AccountNumberListCheckPointImportTypeGet(
          importType,
          accountNumber,
          groupId,
          tenantId,
          acceptLanguage,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     * Permission: accountnumberlist_delete
     * @summary Delete an account number
     * @param {IImportType} importType
     * @param {string} accountNumber
     * @param {string} [groupId]
     * @param {string} [tenantId]
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiV1AccountNumberListImportTypeAccountNumberAccountNumberDelete(
      importType: IImportType,
      accountNumber: string,
      groupId?: string,
      tenantId?: string,
      acceptLanguage?: string,
      options?: any
    ): AxiosPromise<IImportAccountNumberListIRadianseResultSuccess> {
      return localVarFp
        .userApiV1AccountNumberListImportTypeAccountNumberAccountNumberDelete(
          importType,
          accountNumber,
          groupId,
          tenantId,
          acceptLanguage,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     * Permission: accountnumberlist_create
     * @summary Add an account number to the existing list of account numbers
     * @param {IImportType} importType
     * @param {string} accountNumber
     * @param {string} [groupId] If using a group token, include groupId
     * @param {string} [tenantId] If using a tenant token, include tenantId
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiV1AccountNumberListImportTypeAccountNumberAccountNumberPut(
      importType: IImportType,
      accountNumber: string,
      groupId?: string,
      tenantId?: string,
      acceptLanguage?: string,
      options?: any
    ): AxiosPromise<IImportAccountNumberListIRadianseResultSuccess> {
      return localVarFp
        .userApiV1AccountNumberListImportTypeAccountNumberAccountNumberPut(
          importType,
          accountNumber,
          groupId,
          tenantId,
          acceptLanguage,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     * Permission: accountnumberlist_delete
     * @summary Delete the account numbers
     * @param {IImportType} importType
     * @param {string} [groupId] If using a group token, include groupId
     * @param {string} [tenantId] If using a tenant token, include tenantId
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiV1AccountNumberListImportTypeDelete(
      importType: IImportType,
      groupId?: string,
      tenantId?: string,
      acceptLanguage?: string,
      options?: any
    ): AxiosPromise<IImportAccountNumberListIRadianseResultSuccess> {
      return localVarFp
        .userApiV1AccountNumberListImportTypeDelete(
          importType,
          groupId,
          tenantId,
          acceptLanguage,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     * Permission: accountnumberlist_read
     * @summary Get account number to import by type of company to import from.
     * @param {IImportType} importType
     * @param {string} [groupId] If using a group token, include groupId
     * @param {string} [tenantId] If using a tenant token, include tenantId
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiV1AccountNumberListImportTypeGet(
      importType: IImportType,
      groupId?: string,
      tenantId?: string,
      acceptLanguage?: string,
      options?: any
    ): AxiosPromise<IImportAccountNumberListIRadianseResultSuccess> {
      return localVarFp
        .userApiV1AccountNumberListImportTypeGet(
          importType,
          groupId,
          tenantId,
          acceptLanguage,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     * Permission: accountnumberlist_create
     * @summary Put account numbers to import
     * @param {IImportType} importType
     * @param {string} [groupId] If using a group token, include groupId
     * @param {string} [tenantId] If using a tenant token, include tenantId
     * @param {string} [acceptLanguage]
     * @param {IImportAccountNumberListDto} [iImportAccountNumberListDto]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiV1AccountNumberListImportTypePut(
      importType: IImportType,
      groupId?: string,
      tenantId?: string,
      acceptLanguage?: string,
      iImportAccountNumberListDto?: IImportAccountNumberListDto,
      options?: any
    ): AxiosPromise<IImportAccountNumberListIRadianseResultSuccess> {
      return localVarFp
        .userApiV1AccountNumberListImportTypePut(
          importType,
          groupId,
          tenantId,
          acceptLanguage,
          iImportAccountNumberListDto,
          options
        )
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * AccountNumberListApi - object-oriented interface
 * @export
 * @class AccountNumberListApi
 * @extends {BaseAPI}
 */
export class AccountNumberListApi extends BaseAPI {
  /**
   * For ABC, these are in the /membershiptypes
   * @summary Get status of member import by account number (club code)
   * @param {IImportType} importType
   * @param {string} [accountNumber] For planet fitness, this is the club code.
   * @param {string} [groupId]
   * @param {string} [tenantId]
   * @param {string} [apiVersion] The requested API version
   * @param {string} [acceptLanguage]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AccountNumberListApi
   */
  public userApiAccountNumberListCheckPointImportTypeGet(
    importType: IImportType,
    accountNumber?: string,
    groupId?: string,
    tenantId?: string,
    apiVersion?: string,
    acceptLanguage?: string,
    options?: AxiosRequestConfig
  ) {
    return AccountNumberListApiFp(this.configuration)
      .userApiAccountNumberListCheckPointImportTypeGet(
        importType,
        accountNumber,
        groupId,
        tenantId,
        apiVersion,
        acceptLanguage,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Permission: accountnumberlist_delete
   * @summary Delete an account number
   * @param {IImportType} importType
   * @param {string} accountNumber
   * @param {string} [groupId]
   * @param {string} [tenantId]
   * @param {string} [apiVersion] The requested API version
   * @param {string} [acceptLanguage]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AccountNumberListApi
   */
  public userApiAccountNumberListImportTypeAccountNumberAccountNumberDelete(
    importType: IImportType,
    accountNumber: string,
    groupId?: string,
    tenantId?: string,
    apiVersion?: string,
    acceptLanguage?: string,
    options?: AxiosRequestConfig
  ) {
    return AccountNumberListApiFp(this.configuration)
      .userApiAccountNumberListImportTypeAccountNumberAccountNumberDelete(
        importType,
        accountNumber,
        groupId,
        tenantId,
        apiVersion,
        acceptLanguage,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Permission: accountnumberlist_create
   * @summary Add an account number to the existing list of account numbers
   * @param {IImportType} importType
   * @param {string} accountNumber
   * @param {string} [groupId] If using a group token, include groupId
   * @param {string} [tenantId] If using a tenant token, include tenantId
   * @param {string} [apiVersion] The requested API version
   * @param {string} [acceptLanguage]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AccountNumberListApi
   */
  public userApiAccountNumberListImportTypeAccountNumberAccountNumberPut(
    importType: IImportType,
    accountNumber: string,
    groupId?: string,
    tenantId?: string,
    apiVersion?: string,
    acceptLanguage?: string,
    options?: AxiosRequestConfig
  ) {
    return AccountNumberListApiFp(this.configuration)
      .userApiAccountNumberListImportTypeAccountNumberAccountNumberPut(
        importType,
        accountNumber,
        groupId,
        tenantId,
        apiVersion,
        acceptLanguage,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Permission: accountnumberlist_delete
   * @summary Delete the account numbers
   * @param {IImportType} importType
   * @param {string} [groupId] If using a group token, include groupId
   * @param {string} [tenantId] If using a tenant token, include tenantId
   * @param {string} [apiVersion] The requested API version
   * @param {string} [acceptLanguage]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AccountNumberListApi
   */
  public userApiAccountNumberListImportTypeDelete(
    importType: IImportType,
    groupId?: string,
    tenantId?: string,
    apiVersion?: string,
    acceptLanguage?: string,
    options?: AxiosRequestConfig
  ) {
    return AccountNumberListApiFp(this.configuration)
      .userApiAccountNumberListImportTypeDelete(
        importType,
        groupId,
        tenantId,
        apiVersion,
        acceptLanguage,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Permission: accountnumberlist_read
   * @summary Get account number to import by type of company to import from.
   * @param {IImportType} importType
   * @param {string} [groupId] If using a group token, include groupId
   * @param {string} [tenantId] If using a tenant token, include tenantId
   * @param {string} [apiVersion] The requested API version
   * @param {string} [acceptLanguage]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AccountNumberListApi
   */
  public userApiAccountNumberListImportTypeGet(
    importType: IImportType,
    groupId?: string,
    tenantId?: string,
    apiVersion?: string,
    acceptLanguage?: string,
    options?: AxiosRequestConfig
  ) {
    return AccountNumberListApiFp(this.configuration)
      .userApiAccountNumberListImportTypeGet(
        importType,
        groupId,
        tenantId,
        apiVersion,
        acceptLanguage,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Permission: accountnumberlist_create
   * @summary Put account numbers to import
   * @param {IImportType} importType
   * @param {string} [groupId] If using a group token, include groupId
   * @param {string} [tenantId] If using a tenant token, include tenantId
   * @param {string} [apiVersion] The requested API version
   * @param {string} [acceptLanguage]
   * @param {IImportAccountNumberListDto} [iImportAccountNumberListDto]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AccountNumberListApi
   */
  public userApiAccountNumberListImportTypePut(
    importType: IImportType,
    groupId?: string,
    tenantId?: string,
    apiVersion?: string,
    acceptLanguage?: string,
    iImportAccountNumberListDto?: IImportAccountNumberListDto,
    options?: AxiosRequestConfig
  ) {
    return AccountNumberListApiFp(this.configuration)
      .userApiAccountNumberListImportTypePut(
        importType,
        groupId,
        tenantId,
        apiVersion,
        acceptLanguage,
        iImportAccountNumberListDto,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * For ABC, these are in the /membershiptypes
   * @summary Get status of member import by account number (club code)
   * @param {IImportType} importType
   * @param {string} [accountNumber] For planet fitness, this is the club code.
   * @param {string} [groupId]
   * @param {string} [tenantId]
   * @param {string} [acceptLanguage]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AccountNumberListApi
   */
  public userApiV1AccountNumberListCheckPointImportTypeGet(
    importType: IImportType,
    accountNumber?: string,
    groupId?: string,
    tenantId?: string,
    acceptLanguage?: string,
    options?: AxiosRequestConfig
  ) {
    return AccountNumberListApiFp(this.configuration)
      .userApiV1AccountNumberListCheckPointImportTypeGet(
        importType,
        accountNumber,
        groupId,
        tenantId,
        acceptLanguage,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Permission: accountnumberlist_delete
   * @summary Delete an account number
   * @param {IImportType} importType
   * @param {string} accountNumber
   * @param {string} [groupId]
   * @param {string} [tenantId]
   * @param {string} [acceptLanguage]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AccountNumberListApi
   */
  public userApiV1AccountNumberListImportTypeAccountNumberAccountNumberDelete(
    importType: IImportType,
    accountNumber: string,
    groupId?: string,
    tenantId?: string,
    acceptLanguage?: string,
    options?: AxiosRequestConfig
  ) {
    return AccountNumberListApiFp(this.configuration)
      .userApiV1AccountNumberListImportTypeAccountNumberAccountNumberDelete(
        importType,
        accountNumber,
        groupId,
        tenantId,
        acceptLanguage,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Permission: accountnumberlist_create
   * @summary Add an account number to the existing list of account numbers
   * @param {IImportType} importType
   * @param {string} accountNumber
   * @param {string} [groupId] If using a group token, include groupId
   * @param {string} [tenantId] If using a tenant token, include tenantId
   * @param {string} [acceptLanguage]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AccountNumberListApi
   */
  public userApiV1AccountNumberListImportTypeAccountNumberAccountNumberPut(
    importType: IImportType,
    accountNumber: string,
    groupId?: string,
    tenantId?: string,
    acceptLanguage?: string,
    options?: AxiosRequestConfig
  ) {
    return AccountNumberListApiFp(this.configuration)
      .userApiV1AccountNumberListImportTypeAccountNumberAccountNumberPut(
        importType,
        accountNumber,
        groupId,
        tenantId,
        acceptLanguage,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Permission: accountnumberlist_delete
   * @summary Delete the account numbers
   * @param {IImportType} importType
   * @param {string} [groupId] If using a group token, include groupId
   * @param {string} [tenantId] If using a tenant token, include tenantId
   * @param {string} [acceptLanguage]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AccountNumberListApi
   */
  public userApiV1AccountNumberListImportTypeDelete(
    importType: IImportType,
    groupId?: string,
    tenantId?: string,
    acceptLanguage?: string,
    options?: AxiosRequestConfig
  ) {
    return AccountNumberListApiFp(this.configuration)
      .userApiV1AccountNumberListImportTypeDelete(
        importType,
        groupId,
        tenantId,
        acceptLanguage,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Permission: accountnumberlist_read
   * @summary Get account number to import by type of company to import from.
   * @param {IImportType} importType
   * @param {string} [groupId] If using a group token, include groupId
   * @param {string} [tenantId] If using a tenant token, include tenantId
   * @param {string} [acceptLanguage]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AccountNumberListApi
   */
  public userApiV1AccountNumberListImportTypeGet(
    importType: IImportType,
    groupId?: string,
    tenantId?: string,
    acceptLanguage?: string,
    options?: AxiosRequestConfig
  ) {
    return AccountNumberListApiFp(this.configuration)
      .userApiV1AccountNumberListImportTypeGet(
        importType,
        groupId,
        tenantId,
        acceptLanguage,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Permission: accountnumberlist_create
   * @summary Put account numbers to import
   * @param {IImportType} importType
   * @param {string} [groupId] If using a group token, include groupId
   * @param {string} [tenantId] If using a tenant token, include tenantId
   * @param {string} [acceptLanguage]
   * @param {IImportAccountNumberListDto} [iImportAccountNumberListDto]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AccountNumberListApi
   */
  public userApiV1AccountNumberListImportTypePut(
    importType: IImportType,
    groupId?: string,
    tenantId?: string,
    acceptLanguage?: string,
    iImportAccountNumberListDto?: IImportAccountNumberListDto,
    options?: AxiosRequestConfig
  ) {
    return AccountNumberListApiFp(this.configuration)
      .userApiV1AccountNumberListImportTypePut(
        importType,
        groupId,
        tenantId,
        acceptLanguage,
        iImportAccountNumberListDto,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * ImportTypeApi - axios parameter creator
 * @export
 */
export const ImportTypeApiAxiosParamCreator = function (
  configuration?: Configuration
) {
  return {
    /**
     * Permission: importtype_read
     * @summary Get import types and credentials
     * @param {string} [groupId] If using a group token, include groupId
     * @param {string} [tenantId] If using a tenant token, include tenantId
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiImportTypeGet: async (
      groupId?: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/UserApi/ImportType`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "Authorization",
        configuration
      );

      if (groupId !== undefined) {
        localVarQueryParameter["groupId"] = groupId;
      }

      if (tenantId !== undefined) {
        localVarQueryParameter["tenantId"] = tenantId;
      }

      if (apiVersion !== undefined) {
        localVarQueryParameter["api-version"] = apiVersion;
      }

      if (acceptLanguage != null) {
        localVarHeaderParameter["Accept-Language"] = String(acceptLanguage);
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Permission: importtype_delete
     * @summary Delete a credential
     * @param {IImportType} importType
     * @param {string} importCredentialsName
     * @param {string} [groupId]
     * @param {string} [tenantId]
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiImportTypeImportTypeCredentialImportCredentialsNameDelete: async (
      importType: IImportType,
      importCredentialsName: string,
      groupId?: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'importType' is not null or undefined
      assertParamExists(
        "userApiImportTypeImportTypeCredentialImportCredentialsNameDelete",
        "importType",
        importType
      );
      // verify required parameter 'importCredentialsName' is not null or undefined
      assertParamExists(
        "userApiImportTypeImportTypeCredentialImportCredentialsNameDelete",
        "importCredentialsName",
        importCredentialsName
      );
      const localVarPath =
        `/UserApi/ImportType/{importType}/Credential/{importCredentialsName}`
          .replace(`{${"importType"}}`, encodeURIComponent(String(importType)))
          .replace(
            `{${"importCredentialsName"}}`,
            encodeURIComponent(String(importCredentialsName))
          );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "DELETE",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "Authorization",
        configuration
      );

      if (groupId !== undefined) {
        localVarQueryParameter["groupId"] = groupId;
      }

      if (tenantId !== undefined) {
        localVarQueryParameter["tenantId"] = tenantId;
      }

      if (apiVersion !== undefined) {
        localVarQueryParameter["api-version"] = apiVersion;
      }

      if (acceptLanguage != null) {
        localVarHeaderParameter["Accept-Language"] = String(acceptLanguage);
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Permission: importtype_create
     * @summary Add a credential to the existing list of credentials
     * @param {IImportType} importType
     * @param {string} [groupId] If using a group token, include groupId
     * @param {string} [tenantId] If using a tenant token, include tenantId
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {ICredentialsInfo} [iCredentialsInfo]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiImportTypeImportTypeCredentialPut: async (
      importType: IImportType,
      groupId?: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      iCredentialsInfo?: ICredentialsInfo,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'importType' is not null or undefined
      assertParamExists(
        "userApiImportTypeImportTypeCredentialPut",
        "importType",
        importType
      );
      const localVarPath =
        `/UserApi/ImportType/{importType}/Credential`.replace(
          `{${"importType"}}`,
          encodeURIComponent(String(importType))
        );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "PUT",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "Authorization",
        configuration
      );

      if (groupId !== undefined) {
        localVarQueryParameter["groupId"] = groupId;
      }

      if (tenantId !== undefined) {
        localVarQueryParameter["tenantId"] = tenantId;
      }

      if (apiVersion !== undefined) {
        localVarQueryParameter["api-version"] = apiVersion;
      }

      if (acceptLanguage != null) {
        localVarHeaderParameter["Accept-Language"] = String(acceptLanguage);
      }

      localVarHeaderParameter["Content-Type"] = "application/json-patch+json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        iCredentialsInfo,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Permission: importtype_delete
     * @summary Delete the credentials
     * @param {IImportType} importType
     * @param {string} [groupId] If using a group token, include groupId
     * @param {string} [tenantId] If using a tenant token, include tenantId
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiImportTypeImportTypeDelete: async (
      importType: IImportType,
      groupId?: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'importType' is not null or undefined
      assertParamExists(
        "userApiImportTypeImportTypeDelete",
        "importType",
        importType
      );
      const localVarPath = `/UserApi/ImportType/{importType}`.replace(
        `{${"importType"}}`,
        encodeURIComponent(String(importType))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "DELETE",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "Authorization",
        configuration
      );

      if (groupId !== undefined) {
        localVarQueryParameter["groupId"] = groupId;
      }

      if (tenantId !== undefined) {
        localVarQueryParameter["tenantId"] = tenantId;
      }

      if (apiVersion !== undefined) {
        localVarQueryParameter["api-version"] = apiVersion;
      }

      if (acceptLanguage != null) {
        localVarHeaderParameter["Accept-Language"] = String(acceptLanguage);
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Permission: importtype_read
     * @summary Get credentials by import type
     * @param {IImportType} importType
     * @param {string} [groupId] If using a group token, include groupId
     * @param {string} [tenantId] If using a tenant token, include tenantId
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiImportTypeImportTypeGet: async (
      importType: IImportType,
      groupId?: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'importType' is not null or undefined
      assertParamExists(
        "userApiImportTypeImportTypeGet",
        "importType",
        importType
      );
      const localVarPath = `/UserApi/ImportType/{importType}`.replace(
        `{${"importType"}}`,
        encodeURIComponent(String(importType))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "Authorization",
        configuration
      );

      if (groupId !== undefined) {
        localVarQueryParameter["groupId"] = groupId;
      }

      if (tenantId !== undefined) {
        localVarQueryParameter["tenantId"] = tenantId;
      }

      if (apiVersion !== undefined) {
        localVarQueryParameter["api-version"] = apiVersion;
      }

      if (acceptLanguage != null) {
        localVarHeaderParameter["Accept-Language"] = String(acceptLanguage);
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Permission: importtype_create
     * @summary Put credentials to import
     * @param {IImportType} importType
     * @param {string} [groupId] If using a group token, include groupId
     * @param {string} [tenantId] If using a tenant token, include tenantId
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {IImportTypeCredentialsDto} [iImportTypeCredentialsDto]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiImportTypeImportTypePut: async (
      importType: IImportType,
      groupId?: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      iImportTypeCredentialsDto?: IImportTypeCredentialsDto,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'importType' is not null or undefined
      assertParamExists(
        "userApiImportTypeImportTypePut",
        "importType",
        importType
      );
      const localVarPath = `/UserApi/ImportType/{importType}`.replace(
        `{${"importType"}}`,
        encodeURIComponent(String(importType))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "PUT",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "Authorization",
        configuration
      );

      if (groupId !== undefined) {
        localVarQueryParameter["groupId"] = groupId;
      }

      if (tenantId !== undefined) {
        localVarQueryParameter["tenantId"] = tenantId;
      }

      if (apiVersion !== undefined) {
        localVarQueryParameter["api-version"] = apiVersion;
      }

      if (acceptLanguage != null) {
        localVarHeaderParameter["Accept-Language"] = String(acceptLanguage);
      }

      localVarHeaderParameter["Content-Type"] = "application/json-patch+json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        iImportTypeCredentialsDto,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Permission: importtype_read
     * @summary Get import types and credentials
     * @param {string} [groupId] If using a group token, include groupId
     * @param {string} [tenantId] If using a tenant token, include tenantId
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiV1ImportTypeGet: async (
      groupId?: string,
      tenantId?: string,
      acceptLanguage?: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/UserApi/v1/ImportType`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "Authorization",
        configuration
      );

      if (groupId !== undefined) {
        localVarQueryParameter["groupId"] = groupId;
      }

      if (tenantId !== undefined) {
        localVarQueryParameter["tenantId"] = tenantId;
      }

      if (acceptLanguage != null) {
        localVarHeaderParameter["Accept-Language"] = String(acceptLanguage);
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Permission: importtype_delete
     * @summary Delete a credential
     * @param {IImportType} importType
     * @param {string} importCredentialsName
     * @param {string} [groupId]
     * @param {string} [tenantId]
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiV1ImportTypeImportTypeCredentialImportCredentialsNameDelete: async (
      importType: IImportType,
      importCredentialsName: string,
      groupId?: string,
      tenantId?: string,
      acceptLanguage?: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'importType' is not null or undefined
      assertParamExists(
        "userApiV1ImportTypeImportTypeCredentialImportCredentialsNameDelete",
        "importType",
        importType
      );
      // verify required parameter 'importCredentialsName' is not null or undefined
      assertParamExists(
        "userApiV1ImportTypeImportTypeCredentialImportCredentialsNameDelete",
        "importCredentialsName",
        importCredentialsName
      );
      const localVarPath =
        `/UserApi/v1/ImportType/{importType}/Credential/{importCredentialsName}`
          .replace(`{${"importType"}}`, encodeURIComponent(String(importType)))
          .replace(
            `{${"importCredentialsName"}}`,
            encodeURIComponent(String(importCredentialsName))
          );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "DELETE",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "Authorization",
        configuration
      );

      if (groupId !== undefined) {
        localVarQueryParameter["groupId"] = groupId;
      }

      if (tenantId !== undefined) {
        localVarQueryParameter["tenantId"] = tenantId;
      }

      if (acceptLanguage != null) {
        localVarHeaderParameter["Accept-Language"] = String(acceptLanguage);
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Permission: importtype_create
     * @summary Add a credential to the existing list of credentials
     * @param {IImportType} importType
     * @param {string} [groupId] If using a group token, include groupId
     * @param {string} [tenantId] If using a tenant token, include tenantId
     * @param {string} [acceptLanguage]
     * @param {ICredentialsInfo} [iCredentialsInfo]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiV1ImportTypeImportTypeCredentialPut: async (
      importType: IImportType,
      groupId?: string,
      tenantId?: string,
      acceptLanguage?: string,
      iCredentialsInfo?: ICredentialsInfo,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'importType' is not null or undefined
      assertParamExists(
        "userApiV1ImportTypeImportTypeCredentialPut",
        "importType",
        importType
      );
      const localVarPath =
        `/UserApi/v1/ImportType/{importType}/Credential`.replace(
          `{${"importType"}}`,
          encodeURIComponent(String(importType))
        );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "PUT",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "Authorization",
        configuration
      );

      if (groupId !== undefined) {
        localVarQueryParameter["groupId"] = groupId;
      }

      if (tenantId !== undefined) {
        localVarQueryParameter["tenantId"] = tenantId;
      }

      if (acceptLanguage != null) {
        localVarHeaderParameter["Accept-Language"] = String(acceptLanguage);
      }

      localVarHeaderParameter["Content-Type"] = "application/json-patch+json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        iCredentialsInfo,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Permission: importtype_delete
     * @summary Delete the credentials
     * @param {IImportType} importType
     * @param {string} [groupId] If using a group token, include groupId
     * @param {string} [tenantId] If using a tenant token, include tenantId
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiV1ImportTypeImportTypeDelete: async (
      importType: IImportType,
      groupId?: string,
      tenantId?: string,
      acceptLanguage?: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'importType' is not null or undefined
      assertParamExists(
        "userApiV1ImportTypeImportTypeDelete",
        "importType",
        importType
      );
      const localVarPath = `/UserApi/v1/ImportType/{importType}`.replace(
        `{${"importType"}}`,
        encodeURIComponent(String(importType))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "DELETE",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "Authorization",
        configuration
      );

      if (groupId !== undefined) {
        localVarQueryParameter["groupId"] = groupId;
      }

      if (tenantId !== undefined) {
        localVarQueryParameter["tenantId"] = tenantId;
      }

      if (acceptLanguage != null) {
        localVarHeaderParameter["Accept-Language"] = String(acceptLanguage);
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Permission: importtype_read
     * @summary Get credentials by import type
     * @param {IImportType} importType
     * @param {string} [groupId] If using a group token, include groupId
     * @param {string} [tenantId] If using a tenant token, include tenantId
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiV1ImportTypeImportTypeGet: async (
      importType: IImportType,
      groupId?: string,
      tenantId?: string,
      acceptLanguage?: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'importType' is not null or undefined
      assertParamExists(
        "userApiV1ImportTypeImportTypeGet",
        "importType",
        importType
      );
      const localVarPath = `/UserApi/v1/ImportType/{importType}`.replace(
        `{${"importType"}}`,
        encodeURIComponent(String(importType))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "Authorization",
        configuration
      );

      if (groupId !== undefined) {
        localVarQueryParameter["groupId"] = groupId;
      }

      if (tenantId !== undefined) {
        localVarQueryParameter["tenantId"] = tenantId;
      }

      if (acceptLanguage != null) {
        localVarHeaderParameter["Accept-Language"] = String(acceptLanguage);
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Permission: importtype_create
     * @summary Put credentials to import
     * @param {IImportType} importType
     * @param {string} [groupId] If using a group token, include groupId
     * @param {string} [tenantId] If using a tenant token, include tenantId
     * @param {string} [acceptLanguage]
     * @param {IImportTypeCredentialsDto} [iImportTypeCredentialsDto]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiV1ImportTypeImportTypePut: async (
      importType: IImportType,
      groupId?: string,
      tenantId?: string,
      acceptLanguage?: string,
      iImportTypeCredentialsDto?: IImportTypeCredentialsDto,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'importType' is not null or undefined
      assertParamExists(
        "userApiV1ImportTypeImportTypePut",
        "importType",
        importType
      );
      const localVarPath = `/UserApi/v1/ImportType/{importType}`.replace(
        `{${"importType"}}`,
        encodeURIComponent(String(importType))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "PUT",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "Authorization",
        configuration
      );

      if (groupId !== undefined) {
        localVarQueryParameter["groupId"] = groupId;
      }

      if (tenantId !== undefined) {
        localVarQueryParameter["tenantId"] = tenantId;
      }

      if (acceptLanguage != null) {
        localVarHeaderParameter["Accept-Language"] = String(acceptLanguage);
      }

      localVarHeaderParameter["Content-Type"] = "application/json-patch+json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        iImportTypeCredentialsDto,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * ImportTypeApi - functional programming interface
 * @export
 */
export const ImportTypeApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator =
    ImportTypeApiAxiosParamCreator(configuration);
  return {
    /**
     * Permission: importtype_read
     * @summary Get import types and credentials
     * @param {string} [groupId] If using a group token, include groupId
     * @param {string} [tenantId] If using a tenant token, include tenantId
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async userApiImportTypeGet(
      groupId?: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<IImportTypeCredentialsListIRadianseResultSuccess>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.userApiImportTypeGet(
          groupId,
          tenantId,
          apiVersion,
          acceptLanguage,
          options
        );
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap["ImportTypeApi.userApiImportTypeGet"]?.[index]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, operationBasePath || basePath);
    },
    /**
     * Permission: importtype_delete
     * @summary Delete a credential
     * @param {IImportType} importType
     * @param {string} importCredentialsName
     * @param {string} [groupId]
     * @param {string} [tenantId]
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async userApiImportTypeImportTypeCredentialImportCredentialsNameDelete(
      importType: IImportType,
      importCredentialsName: string,
      groupId?: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<IImportTypeCredentialsIRadianseResultSuccess>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.userApiImportTypeImportTypeCredentialImportCredentialsNameDelete(
          importType,
          importCredentialsName,
          groupId,
          tenantId,
          apiVersion,
          acceptLanguage,
          options
        );
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap[
          "ImportTypeApi.userApiImportTypeImportTypeCredentialImportCredentialsNameDelete"
        ]?.[index]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, operationBasePath || basePath);
    },
    /**
     * Permission: importtype_create
     * @summary Add a credential to the existing list of credentials
     * @param {IImportType} importType
     * @param {string} [groupId] If using a group token, include groupId
     * @param {string} [tenantId] If using a tenant token, include tenantId
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {ICredentialsInfo} [iCredentialsInfo]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async userApiImportTypeImportTypeCredentialPut(
      importType: IImportType,
      groupId?: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      iCredentialsInfo?: ICredentialsInfo,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<IImportTypeCredentialsIRadianseResultSuccess>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.userApiImportTypeImportTypeCredentialPut(
          importType,
          groupId,
          tenantId,
          apiVersion,
          acceptLanguage,
          iCredentialsInfo,
          options
        );
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap[
          "ImportTypeApi.userApiImportTypeImportTypeCredentialPut"
        ]?.[index]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, operationBasePath || basePath);
    },
    /**
     * Permission: importtype_delete
     * @summary Delete the credentials
     * @param {IImportType} importType
     * @param {string} [groupId] If using a group token, include groupId
     * @param {string} [tenantId] If using a tenant token, include tenantId
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async userApiImportTypeImportTypeDelete(
      importType: IImportType,
      groupId?: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<IImportTypeCredentialsIRadianseResultSuccess>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.userApiImportTypeImportTypeDelete(
          importType,
          groupId,
          tenantId,
          apiVersion,
          acceptLanguage,
          options
        );
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap["ImportTypeApi.userApiImportTypeImportTypeDelete"]?.[
          index
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, operationBasePath || basePath);
    },
    /**
     * Permission: importtype_read
     * @summary Get credentials by import type
     * @param {IImportType} importType
     * @param {string} [groupId] If using a group token, include groupId
     * @param {string} [tenantId] If using a tenant token, include tenantId
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async userApiImportTypeImportTypeGet(
      importType: IImportType,
      groupId?: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<IImportTypeCredentialsIRadianseResultSuccess>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.userApiImportTypeImportTypeGet(
          importType,
          groupId,
          tenantId,
          apiVersion,
          acceptLanguage,
          options
        );
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap["ImportTypeApi.userApiImportTypeImportTypeGet"]?.[
          index
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, operationBasePath || basePath);
    },
    /**
     * Permission: importtype_create
     * @summary Put credentials to import
     * @param {IImportType} importType
     * @param {string} [groupId] If using a group token, include groupId
     * @param {string} [tenantId] If using a tenant token, include tenantId
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {IImportTypeCredentialsDto} [iImportTypeCredentialsDto]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async userApiImportTypeImportTypePut(
      importType: IImportType,
      groupId?: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      iImportTypeCredentialsDto?: IImportTypeCredentialsDto,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<IImportTypeCredentialsIRadianseResultSuccess>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.userApiImportTypeImportTypePut(
          importType,
          groupId,
          tenantId,
          apiVersion,
          acceptLanguage,
          iImportTypeCredentialsDto,
          options
        );
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap["ImportTypeApi.userApiImportTypeImportTypePut"]?.[
          index
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, operationBasePath || basePath);
    },
    /**
     * Permission: importtype_read
     * @summary Get import types and credentials
     * @param {string} [groupId] If using a group token, include groupId
     * @param {string} [tenantId] If using a tenant token, include tenantId
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async userApiV1ImportTypeGet(
      groupId?: string,
      tenantId?: string,
      acceptLanguage?: string,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<IImportTypeCredentialsListIRadianseResultSuccess>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.userApiV1ImportTypeGet(
          groupId,
          tenantId,
          acceptLanguage,
          options
        );
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap["ImportTypeApi.userApiV1ImportTypeGet"]?.[index]
          ?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, operationBasePath || basePath);
    },
    /**
     * Permission: importtype_delete
     * @summary Delete a credential
     * @param {IImportType} importType
     * @param {string} importCredentialsName
     * @param {string} [groupId]
     * @param {string} [tenantId]
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async userApiV1ImportTypeImportTypeCredentialImportCredentialsNameDelete(
      importType: IImportType,
      importCredentialsName: string,
      groupId?: string,
      tenantId?: string,
      acceptLanguage?: string,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<IImportTypeCredentialsIRadianseResultSuccess>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.userApiV1ImportTypeImportTypeCredentialImportCredentialsNameDelete(
          importType,
          importCredentialsName,
          groupId,
          tenantId,
          acceptLanguage,
          options
        );
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap[
          "ImportTypeApi.userApiV1ImportTypeImportTypeCredentialImportCredentialsNameDelete"
        ]?.[index]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, operationBasePath || basePath);
    },
    /**
     * Permission: importtype_create
     * @summary Add a credential to the existing list of credentials
     * @param {IImportType} importType
     * @param {string} [groupId] If using a group token, include groupId
     * @param {string} [tenantId] If using a tenant token, include tenantId
     * @param {string} [acceptLanguage]
     * @param {ICredentialsInfo} [iCredentialsInfo]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async userApiV1ImportTypeImportTypeCredentialPut(
      importType: IImportType,
      groupId?: string,
      tenantId?: string,
      acceptLanguage?: string,
      iCredentialsInfo?: ICredentialsInfo,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<IImportTypeCredentialsIRadianseResultSuccess>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.userApiV1ImportTypeImportTypeCredentialPut(
          importType,
          groupId,
          tenantId,
          acceptLanguage,
          iCredentialsInfo,
          options
        );
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap[
          "ImportTypeApi.userApiV1ImportTypeImportTypeCredentialPut"
        ]?.[index]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, operationBasePath || basePath);
    },
    /**
     * Permission: importtype_delete
     * @summary Delete the credentials
     * @param {IImportType} importType
     * @param {string} [groupId] If using a group token, include groupId
     * @param {string} [tenantId] If using a tenant token, include tenantId
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async userApiV1ImportTypeImportTypeDelete(
      importType: IImportType,
      groupId?: string,
      tenantId?: string,
      acceptLanguage?: string,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<IImportTypeCredentialsIRadianseResultSuccess>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.userApiV1ImportTypeImportTypeDelete(
          importType,
          groupId,
          tenantId,
          acceptLanguage,
          options
        );
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap[
          "ImportTypeApi.userApiV1ImportTypeImportTypeDelete"
        ]?.[index]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, operationBasePath || basePath);
    },
    /**
     * Permission: importtype_read
     * @summary Get credentials by import type
     * @param {IImportType} importType
     * @param {string} [groupId] If using a group token, include groupId
     * @param {string} [tenantId] If using a tenant token, include tenantId
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async userApiV1ImportTypeImportTypeGet(
      importType: IImportType,
      groupId?: string,
      tenantId?: string,
      acceptLanguage?: string,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<IImportTypeCredentialsIRadianseResultSuccess>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.userApiV1ImportTypeImportTypeGet(
          importType,
          groupId,
          tenantId,
          acceptLanguage,
          options
        );
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap["ImportTypeApi.userApiV1ImportTypeImportTypeGet"]?.[
          index
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, operationBasePath || basePath);
    },
    /**
     * Permission: importtype_create
     * @summary Put credentials to import
     * @param {IImportType} importType
     * @param {string} [groupId] If using a group token, include groupId
     * @param {string} [tenantId] If using a tenant token, include tenantId
     * @param {string} [acceptLanguage]
     * @param {IImportTypeCredentialsDto} [iImportTypeCredentialsDto]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async userApiV1ImportTypeImportTypePut(
      importType: IImportType,
      groupId?: string,
      tenantId?: string,
      acceptLanguage?: string,
      iImportTypeCredentialsDto?: IImportTypeCredentialsDto,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<IImportTypeCredentialsIRadianseResultSuccess>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.userApiV1ImportTypeImportTypePut(
          importType,
          groupId,
          tenantId,
          acceptLanguage,
          iImportTypeCredentialsDto,
          options
        );
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap["ImportTypeApi.userApiV1ImportTypeImportTypePut"]?.[
          index
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, operationBasePath || basePath);
    },
  };
};

/**
 * ImportTypeApi - factory interface
 * @export
 */
export const ImportTypeApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = ImportTypeApiFp(configuration);
  return {
    /**
     * Permission: importtype_read
     * @summary Get import types and credentials
     * @param {string} [groupId] If using a group token, include groupId
     * @param {string} [tenantId] If using a tenant token, include tenantId
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiImportTypeGet(
      groupId?: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options?: any
    ): AxiosPromise<IImportTypeCredentialsListIRadianseResultSuccess> {
      return localVarFp
        .userApiImportTypeGet(
          groupId,
          tenantId,
          apiVersion,
          acceptLanguage,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     * Permission: importtype_delete
     * @summary Delete a credential
     * @param {IImportType} importType
     * @param {string} importCredentialsName
     * @param {string} [groupId]
     * @param {string} [tenantId]
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiImportTypeImportTypeCredentialImportCredentialsNameDelete(
      importType: IImportType,
      importCredentialsName: string,
      groupId?: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options?: any
    ): AxiosPromise<IImportTypeCredentialsIRadianseResultSuccess> {
      return localVarFp
        .userApiImportTypeImportTypeCredentialImportCredentialsNameDelete(
          importType,
          importCredentialsName,
          groupId,
          tenantId,
          apiVersion,
          acceptLanguage,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     * Permission: importtype_create
     * @summary Add a credential to the existing list of credentials
     * @param {IImportType} importType
     * @param {string} [groupId] If using a group token, include groupId
     * @param {string} [tenantId] If using a tenant token, include tenantId
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {ICredentialsInfo} [iCredentialsInfo]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiImportTypeImportTypeCredentialPut(
      importType: IImportType,
      groupId?: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      iCredentialsInfo?: ICredentialsInfo,
      options?: any
    ): AxiosPromise<IImportTypeCredentialsIRadianseResultSuccess> {
      return localVarFp
        .userApiImportTypeImportTypeCredentialPut(
          importType,
          groupId,
          tenantId,
          apiVersion,
          acceptLanguage,
          iCredentialsInfo,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     * Permission: importtype_delete
     * @summary Delete the credentials
     * @param {IImportType} importType
     * @param {string} [groupId] If using a group token, include groupId
     * @param {string} [tenantId] If using a tenant token, include tenantId
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiImportTypeImportTypeDelete(
      importType: IImportType,
      groupId?: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options?: any
    ): AxiosPromise<IImportTypeCredentialsIRadianseResultSuccess> {
      return localVarFp
        .userApiImportTypeImportTypeDelete(
          importType,
          groupId,
          tenantId,
          apiVersion,
          acceptLanguage,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     * Permission: importtype_read
     * @summary Get credentials by import type
     * @param {IImportType} importType
     * @param {string} [groupId] If using a group token, include groupId
     * @param {string} [tenantId] If using a tenant token, include tenantId
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiImportTypeImportTypeGet(
      importType: IImportType,
      groupId?: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options?: any
    ): AxiosPromise<IImportTypeCredentialsIRadianseResultSuccess> {
      return localVarFp
        .userApiImportTypeImportTypeGet(
          importType,
          groupId,
          tenantId,
          apiVersion,
          acceptLanguage,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     * Permission: importtype_create
     * @summary Put credentials to import
     * @param {IImportType} importType
     * @param {string} [groupId] If using a group token, include groupId
     * @param {string} [tenantId] If using a tenant token, include tenantId
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {IImportTypeCredentialsDto} [iImportTypeCredentialsDto]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiImportTypeImportTypePut(
      importType: IImportType,
      groupId?: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      iImportTypeCredentialsDto?: IImportTypeCredentialsDto,
      options?: any
    ): AxiosPromise<IImportTypeCredentialsIRadianseResultSuccess> {
      return localVarFp
        .userApiImportTypeImportTypePut(
          importType,
          groupId,
          tenantId,
          apiVersion,
          acceptLanguage,
          iImportTypeCredentialsDto,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     * Permission: importtype_read
     * @summary Get import types and credentials
     * @param {string} [groupId] If using a group token, include groupId
     * @param {string} [tenantId] If using a tenant token, include tenantId
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiV1ImportTypeGet(
      groupId?: string,
      tenantId?: string,
      acceptLanguage?: string,
      options?: any
    ): AxiosPromise<IImportTypeCredentialsListIRadianseResultSuccess> {
      return localVarFp
        .userApiV1ImportTypeGet(groupId, tenantId, acceptLanguage, options)
        .then((request) => request(axios, basePath));
    },
    /**
     * Permission: importtype_delete
     * @summary Delete a credential
     * @param {IImportType} importType
     * @param {string} importCredentialsName
     * @param {string} [groupId]
     * @param {string} [tenantId]
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiV1ImportTypeImportTypeCredentialImportCredentialsNameDelete(
      importType: IImportType,
      importCredentialsName: string,
      groupId?: string,
      tenantId?: string,
      acceptLanguage?: string,
      options?: any
    ): AxiosPromise<IImportTypeCredentialsIRadianseResultSuccess> {
      return localVarFp
        .userApiV1ImportTypeImportTypeCredentialImportCredentialsNameDelete(
          importType,
          importCredentialsName,
          groupId,
          tenantId,
          acceptLanguage,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     * Permission: importtype_create
     * @summary Add a credential to the existing list of credentials
     * @param {IImportType} importType
     * @param {string} [groupId] If using a group token, include groupId
     * @param {string} [tenantId] If using a tenant token, include tenantId
     * @param {string} [acceptLanguage]
     * @param {ICredentialsInfo} [iCredentialsInfo]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiV1ImportTypeImportTypeCredentialPut(
      importType: IImportType,
      groupId?: string,
      tenantId?: string,
      acceptLanguage?: string,
      iCredentialsInfo?: ICredentialsInfo,
      options?: any
    ): AxiosPromise<IImportTypeCredentialsIRadianseResultSuccess> {
      return localVarFp
        .userApiV1ImportTypeImportTypeCredentialPut(
          importType,
          groupId,
          tenantId,
          acceptLanguage,
          iCredentialsInfo,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     * Permission: importtype_delete
     * @summary Delete the credentials
     * @param {IImportType} importType
     * @param {string} [groupId] If using a group token, include groupId
     * @param {string} [tenantId] If using a tenant token, include tenantId
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiV1ImportTypeImportTypeDelete(
      importType: IImportType,
      groupId?: string,
      tenantId?: string,
      acceptLanguage?: string,
      options?: any
    ): AxiosPromise<IImportTypeCredentialsIRadianseResultSuccess> {
      return localVarFp
        .userApiV1ImportTypeImportTypeDelete(
          importType,
          groupId,
          tenantId,
          acceptLanguage,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     * Permission: importtype_read
     * @summary Get credentials by import type
     * @param {IImportType} importType
     * @param {string} [groupId] If using a group token, include groupId
     * @param {string} [tenantId] If using a tenant token, include tenantId
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiV1ImportTypeImportTypeGet(
      importType: IImportType,
      groupId?: string,
      tenantId?: string,
      acceptLanguage?: string,
      options?: any
    ): AxiosPromise<IImportTypeCredentialsIRadianseResultSuccess> {
      return localVarFp
        .userApiV1ImportTypeImportTypeGet(
          importType,
          groupId,
          tenantId,
          acceptLanguage,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     * Permission: importtype_create
     * @summary Put credentials to import
     * @param {IImportType} importType
     * @param {string} [groupId] If using a group token, include groupId
     * @param {string} [tenantId] If using a tenant token, include tenantId
     * @param {string} [acceptLanguage]
     * @param {IImportTypeCredentialsDto} [iImportTypeCredentialsDto]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiV1ImportTypeImportTypePut(
      importType: IImportType,
      groupId?: string,
      tenantId?: string,
      acceptLanguage?: string,
      iImportTypeCredentialsDto?: IImportTypeCredentialsDto,
      options?: any
    ): AxiosPromise<IImportTypeCredentialsIRadianseResultSuccess> {
      return localVarFp
        .userApiV1ImportTypeImportTypePut(
          importType,
          groupId,
          tenantId,
          acceptLanguage,
          iImportTypeCredentialsDto,
          options
        )
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * ImportTypeApi - object-oriented interface
 * @export
 * @class ImportTypeApi
 * @extends {BaseAPI}
 */
export class ImportTypeApi extends BaseAPI {
  /**
   * Permission: importtype_read
   * @summary Get import types and credentials
   * @param {string} [groupId] If using a group token, include groupId
   * @param {string} [tenantId] If using a tenant token, include tenantId
   * @param {string} [apiVersion] The requested API version
   * @param {string} [acceptLanguage]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ImportTypeApi
   */
  public userApiImportTypeGet(
    groupId?: string,
    tenantId?: string,
    apiVersion?: string,
    acceptLanguage?: string,
    options?: AxiosRequestConfig
  ) {
    return ImportTypeApiFp(this.configuration)
      .userApiImportTypeGet(
        groupId,
        tenantId,
        apiVersion,
        acceptLanguage,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Permission: importtype_delete
   * @summary Delete a credential
   * @param {IImportType} importType
   * @param {string} importCredentialsName
   * @param {string} [groupId]
   * @param {string} [tenantId]
   * @param {string} [apiVersion] The requested API version
   * @param {string} [acceptLanguage]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ImportTypeApi
   */
  public userApiImportTypeImportTypeCredentialImportCredentialsNameDelete(
    importType: IImportType,
    importCredentialsName: string,
    groupId?: string,
    tenantId?: string,
    apiVersion?: string,
    acceptLanguage?: string,
    options?: AxiosRequestConfig
  ) {
    return ImportTypeApiFp(this.configuration)
      .userApiImportTypeImportTypeCredentialImportCredentialsNameDelete(
        importType,
        importCredentialsName,
        groupId,
        tenantId,
        apiVersion,
        acceptLanguage,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Permission: importtype_create
   * @summary Add a credential to the existing list of credentials
   * @param {IImportType} importType
   * @param {string} [groupId] If using a group token, include groupId
   * @param {string} [tenantId] If using a tenant token, include tenantId
   * @param {string} [apiVersion] The requested API version
   * @param {string} [acceptLanguage]
   * @param {ICredentialsInfo} [iCredentialsInfo]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ImportTypeApi
   */
  public userApiImportTypeImportTypeCredentialPut(
    importType: IImportType,
    groupId?: string,
    tenantId?: string,
    apiVersion?: string,
    acceptLanguage?: string,
    iCredentialsInfo?: ICredentialsInfo,
    options?: AxiosRequestConfig
  ) {
    return ImportTypeApiFp(this.configuration)
      .userApiImportTypeImportTypeCredentialPut(
        importType,
        groupId,
        tenantId,
        apiVersion,
        acceptLanguage,
        iCredentialsInfo,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Permission: importtype_delete
   * @summary Delete the credentials
   * @param {IImportType} importType
   * @param {string} [groupId] If using a group token, include groupId
   * @param {string} [tenantId] If using a tenant token, include tenantId
   * @param {string} [apiVersion] The requested API version
   * @param {string} [acceptLanguage]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ImportTypeApi
   */
  public userApiImportTypeImportTypeDelete(
    importType: IImportType,
    groupId?: string,
    tenantId?: string,
    apiVersion?: string,
    acceptLanguage?: string,
    options?: AxiosRequestConfig
  ) {
    return ImportTypeApiFp(this.configuration)
      .userApiImportTypeImportTypeDelete(
        importType,
        groupId,
        tenantId,
        apiVersion,
        acceptLanguage,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Permission: importtype_read
   * @summary Get credentials by import type
   * @param {IImportType} importType
   * @param {string} [groupId] If using a group token, include groupId
   * @param {string} [tenantId] If using a tenant token, include tenantId
   * @param {string} [apiVersion] The requested API version
   * @param {string} [acceptLanguage]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ImportTypeApi
   */
  public userApiImportTypeImportTypeGet(
    importType: IImportType,
    groupId?: string,
    tenantId?: string,
    apiVersion?: string,
    acceptLanguage?: string,
    options?: AxiosRequestConfig
  ) {
    return ImportTypeApiFp(this.configuration)
      .userApiImportTypeImportTypeGet(
        importType,
        groupId,
        tenantId,
        apiVersion,
        acceptLanguage,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Permission: importtype_create
   * @summary Put credentials to import
   * @param {IImportType} importType
   * @param {string} [groupId] If using a group token, include groupId
   * @param {string} [tenantId] If using a tenant token, include tenantId
   * @param {string} [apiVersion] The requested API version
   * @param {string} [acceptLanguage]
   * @param {IImportTypeCredentialsDto} [iImportTypeCredentialsDto]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ImportTypeApi
   */
  public userApiImportTypeImportTypePut(
    importType: IImportType,
    groupId?: string,
    tenantId?: string,
    apiVersion?: string,
    acceptLanguage?: string,
    iImportTypeCredentialsDto?: IImportTypeCredentialsDto,
    options?: AxiosRequestConfig
  ) {
    return ImportTypeApiFp(this.configuration)
      .userApiImportTypeImportTypePut(
        importType,
        groupId,
        tenantId,
        apiVersion,
        acceptLanguage,
        iImportTypeCredentialsDto,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Permission: importtype_read
   * @summary Get import types and credentials
   * @param {string} [groupId] If using a group token, include groupId
   * @param {string} [tenantId] If using a tenant token, include tenantId
   * @param {string} [acceptLanguage]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ImportTypeApi
   */
  public userApiV1ImportTypeGet(
    groupId?: string,
    tenantId?: string,
    acceptLanguage?: string,
    options?: AxiosRequestConfig
  ) {
    return ImportTypeApiFp(this.configuration)
      .userApiV1ImportTypeGet(groupId, tenantId, acceptLanguage, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Permission: importtype_delete
   * @summary Delete a credential
   * @param {IImportType} importType
   * @param {string} importCredentialsName
   * @param {string} [groupId]
   * @param {string} [tenantId]
   * @param {string} [acceptLanguage]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ImportTypeApi
   */
  public userApiV1ImportTypeImportTypeCredentialImportCredentialsNameDelete(
    importType: IImportType,
    importCredentialsName: string,
    groupId?: string,
    tenantId?: string,
    acceptLanguage?: string,
    options?: AxiosRequestConfig
  ) {
    return ImportTypeApiFp(this.configuration)
      .userApiV1ImportTypeImportTypeCredentialImportCredentialsNameDelete(
        importType,
        importCredentialsName,
        groupId,
        tenantId,
        acceptLanguage,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Permission: importtype_create
   * @summary Add a credential to the existing list of credentials
   * @param {IImportType} importType
   * @param {string} [groupId] If using a group token, include groupId
   * @param {string} [tenantId] If using a tenant token, include tenantId
   * @param {string} [acceptLanguage]
   * @param {ICredentialsInfo} [iCredentialsInfo]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ImportTypeApi
   */
  public userApiV1ImportTypeImportTypeCredentialPut(
    importType: IImportType,
    groupId?: string,
    tenantId?: string,
    acceptLanguage?: string,
    iCredentialsInfo?: ICredentialsInfo,
    options?: AxiosRequestConfig
  ) {
    return ImportTypeApiFp(this.configuration)
      .userApiV1ImportTypeImportTypeCredentialPut(
        importType,
        groupId,
        tenantId,
        acceptLanguage,
        iCredentialsInfo,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Permission: importtype_delete
   * @summary Delete the credentials
   * @param {IImportType} importType
   * @param {string} [groupId] If using a group token, include groupId
   * @param {string} [tenantId] If using a tenant token, include tenantId
   * @param {string} [acceptLanguage]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ImportTypeApi
   */
  public userApiV1ImportTypeImportTypeDelete(
    importType: IImportType,
    groupId?: string,
    tenantId?: string,
    acceptLanguage?: string,
    options?: AxiosRequestConfig
  ) {
    return ImportTypeApiFp(this.configuration)
      .userApiV1ImportTypeImportTypeDelete(
        importType,
        groupId,
        tenantId,
        acceptLanguage,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Permission: importtype_read
   * @summary Get credentials by import type
   * @param {IImportType} importType
   * @param {string} [groupId] If using a group token, include groupId
   * @param {string} [tenantId] If using a tenant token, include tenantId
   * @param {string} [acceptLanguage]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ImportTypeApi
   */
  public userApiV1ImportTypeImportTypeGet(
    importType: IImportType,
    groupId?: string,
    tenantId?: string,
    acceptLanguage?: string,
    options?: AxiosRequestConfig
  ) {
    return ImportTypeApiFp(this.configuration)
      .userApiV1ImportTypeImportTypeGet(
        importType,
        groupId,
        tenantId,
        acceptLanguage,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Permission: importtype_create
   * @summary Put credentials to import
   * @param {IImportType} importType
   * @param {string} [groupId] If using a group token, include groupId
   * @param {string} [tenantId] If using a tenant token, include tenantId
   * @param {string} [acceptLanguage]
   * @param {IImportTypeCredentialsDto} [iImportTypeCredentialsDto]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ImportTypeApi
   */
  public userApiV1ImportTypeImportTypePut(
    importType: IImportType,
    groupId?: string,
    tenantId?: string,
    acceptLanguage?: string,
    iImportTypeCredentialsDto?: IImportTypeCredentialsDto,
    options?: AxiosRequestConfig
  ) {
    return ImportTypeApiFp(this.configuration)
      .userApiV1ImportTypeImportTypePut(
        importType,
        groupId,
        tenantId,
        acceptLanguage,
        iImportTypeCredentialsDto,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * MemberImportApi - axios parameter creator
 * @export
 */
export const MemberImportApiAxiosParamCreator = function (
  configuration?: Configuration
) {
  return {
    /**
     * Permission: member_read
     * @summary Get the member
     * @param {IImportType} importType
     * @param {string} [accountNumber] If account number is not known, attempts to find account number from tenantId
     * @param {string} [memberId] Member ID
     * @param {string} [memberBarcode] Member barcode
     * @param {string} [groupId] If using a group token, include groupId
     * @param {string} [tenantId] If using a tenant token, include tenantId
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiMemberImportTypeGet: async (
      importType: IImportType,
      accountNumber?: string,
      memberId?: string,
      memberBarcode?: string,
      groupId?: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'importType' is not null or undefined
      assertParamExists("userApiMemberImportTypeGet", "importType", importType);
      const localVarPath = `/UserApi/Member/{importType}`.replace(
        `{${"importType"}}`,
        encodeURIComponent(String(importType))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "Authorization",
        configuration
      );

      if (accountNumber !== undefined) {
        localVarQueryParameter["accountNumber"] = accountNumber;
      }

      if (memberId !== undefined) {
        localVarQueryParameter["memberId"] = memberId;
      }

      if (memberBarcode !== undefined) {
        localVarQueryParameter["memberBarcode"] = memberBarcode;
      }

      if (groupId !== undefined) {
        localVarQueryParameter["groupId"] = groupId;
      }

      if (tenantId !== undefined) {
        localVarQueryParameter["tenantId"] = tenantId;
      }

      if (apiVersion !== undefined) {
        localVarQueryParameter["api-version"] = apiVersion;
      }

      if (acceptLanguage != null) {
        localVarHeaderParameter["Accept-Language"] = String(acceptLanguage);
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Permission: member_read
     * @summary Get the member
     * @param {IImportType} importType
     * @param {string} [accountNumber] If account number is not known, attempts to find account number from tenantId
     * @param {string} [memberId] Member ID
     * @param {string} [memberBarcode] Member barcode
     * @param {string} [groupId] If using a group token, include groupId
     * @param {string} [tenantId] If using a tenant token, include tenantId
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiV1MemberImportTypeGet: async (
      importType: IImportType,
      accountNumber?: string,
      memberId?: string,
      memberBarcode?: string,
      groupId?: string,
      tenantId?: string,
      acceptLanguage?: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'importType' is not null or undefined
      assertParamExists(
        "userApiV1MemberImportTypeGet",
        "importType",
        importType
      );
      const localVarPath = `/UserApi/v1/Member/{importType}`.replace(
        `{${"importType"}}`,
        encodeURIComponent(String(importType))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "Authorization",
        configuration
      );

      if (accountNumber !== undefined) {
        localVarQueryParameter["accountNumber"] = accountNumber;
      }

      if (memberId !== undefined) {
        localVarQueryParameter["memberId"] = memberId;
      }

      if (memberBarcode !== undefined) {
        localVarQueryParameter["memberBarcode"] = memberBarcode;
      }

      if (groupId !== undefined) {
        localVarQueryParameter["groupId"] = groupId;
      }

      if (tenantId !== undefined) {
        localVarQueryParameter["tenantId"] = tenantId;
      }

      if (acceptLanguage != null) {
        localVarHeaderParameter["Accept-Language"] = String(acceptLanguage);
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * MemberImportApi - functional programming interface
 * @export
 */
export const MemberImportApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator =
    MemberImportApiAxiosParamCreator(configuration);
  return {
    /**
     * Permission: member_read
     * @summary Get the member
     * @param {IImportType} importType
     * @param {string} [accountNumber] If account number is not known, attempts to find account number from tenantId
     * @param {string} [memberId] Member ID
     * @param {string} [memberBarcode] Member barcode
     * @param {string} [groupId] If using a group token, include groupId
     * @param {string} [tenantId] If using a tenant token, include tenantId
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async userApiMemberImportTypeGet(
      importType: IImportType,
      accountNumber?: string,
      memberId?: string,
      memberBarcode?: string,
      groupId?: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<IMemberListIRadianseResultSuccess>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.userApiMemberImportTypeGet(
          importType,
          accountNumber,
          memberId,
          memberBarcode,
          groupId,
          tenantId,
          apiVersion,
          acceptLanguage,
          options
        );
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap["MemberImportApi.userApiMemberImportTypeGet"]?.[
          index
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, operationBasePath || basePath);
    },
    /**
     * Permission: member_read
     * @summary Get the member
     * @param {IImportType} importType
     * @param {string} [accountNumber] If account number is not known, attempts to find account number from tenantId
     * @param {string} [memberId] Member ID
     * @param {string} [memberBarcode] Member barcode
     * @param {string} [groupId] If using a group token, include groupId
     * @param {string} [tenantId] If using a tenant token, include tenantId
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async userApiV1MemberImportTypeGet(
      importType: IImportType,
      accountNumber?: string,
      memberId?: string,
      memberBarcode?: string,
      groupId?: string,
      tenantId?: string,
      acceptLanguage?: string,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<IMemberListIRadianseResultSuccess>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.userApiV1MemberImportTypeGet(
          importType,
          accountNumber,
          memberId,
          memberBarcode,
          groupId,
          tenantId,
          acceptLanguage,
          options
        );
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap["MemberImportApi.userApiV1MemberImportTypeGet"]?.[
          index
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, operationBasePath || basePath);
    },
  };
};

/**
 * MemberImportApi - factory interface
 * @export
 */
export const MemberImportApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = MemberImportApiFp(configuration);
  return {
    /**
     * Permission: member_read
     * @summary Get the member
     * @param {IImportType} importType
     * @param {string} [accountNumber] If account number is not known, attempts to find account number from tenantId
     * @param {string} [memberId] Member ID
     * @param {string} [memberBarcode] Member barcode
     * @param {string} [groupId] If using a group token, include groupId
     * @param {string} [tenantId] If using a tenant token, include tenantId
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiMemberImportTypeGet(
      importType: IImportType,
      accountNumber?: string,
      memberId?: string,
      memberBarcode?: string,
      groupId?: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options?: any
    ): AxiosPromise<IMemberListIRadianseResultSuccess> {
      return localVarFp
        .userApiMemberImportTypeGet(
          importType,
          accountNumber,
          memberId,
          memberBarcode,
          groupId,
          tenantId,
          apiVersion,
          acceptLanguage,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     * Permission: member_read
     * @summary Get the member
     * @param {IImportType} importType
     * @param {string} [accountNumber] If account number is not known, attempts to find account number from tenantId
     * @param {string} [memberId] Member ID
     * @param {string} [memberBarcode] Member barcode
     * @param {string} [groupId] If using a group token, include groupId
     * @param {string} [tenantId] If using a tenant token, include tenantId
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiV1MemberImportTypeGet(
      importType: IImportType,
      accountNumber?: string,
      memberId?: string,
      memberBarcode?: string,
      groupId?: string,
      tenantId?: string,
      acceptLanguage?: string,
      options?: any
    ): AxiosPromise<IMemberListIRadianseResultSuccess> {
      return localVarFp
        .userApiV1MemberImportTypeGet(
          importType,
          accountNumber,
          memberId,
          memberBarcode,
          groupId,
          tenantId,
          acceptLanguage,
          options
        )
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * MemberImportApi - object-oriented interface
 * @export
 * @class MemberImportApi
 * @extends {BaseAPI}
 */
export class MemberImportApi extends BaseAPI {
  /**
   * Permission: member_read
   * @summary Get the member
   * @param {IImportType} importType
   * @param {string} [accountNumber] If account number is not known, attempts to find account number from tenantId
   * @param {string} [memberId] Member ID
   * @param {string} [memberBarcode] Member barcode
   * @param {string} [groupId] If using a group token, include groupId
   * @param {string} [tenantId] If using a tenant token, include tenantId
   * @param {string} [apiVersion] The requested API version
   * @param {string} [acceptLanguage]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof MemberImportApi
   */
  public userApiMemberImportTypeGet(
    importType: IImportType,
    accountNumber?: string,
    memberId?: string,
    memberBarcode?: string,
    groupId?: string,
    tenantId?: string,
    apiVersion?: string,
    acceptLanguage?: string,
    options?: AxiosRequestConfig
  ) {
    return MemberImportApiFp(this.configuration)
      .userApiMemberImportTypeGet(
        importType,
        accountNumber,
        memberId,
        memberBarcode,
        groupId,
        tenantId,
        apiVersion,
        acceptLanguage,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Permission: member_read
   * @summary Get the member
   * @param {IImportType} importType
   * @param {string} [accountNumber] If account number is not known, attempts to find account number from tenantId
   * @param {string} [memberId] Member ID
   * @param {string} [memberBarcode] Member barcode
   * @param {string} [groupId] If using a group token, include groupId
   * @param {string} [tenantId] If using a tenant token, include tenantId
   * @param {string} [acceptLanguage]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof MemberImportApi
   */
  public userApiV1MemberImportTypeGet(
    importType: IImportType,
    accountNumber?: string,
    memberId?: string,
    memberBarcode?: string,
    groupId?: string,
    tenantId?: string,
    acceptLanguage?: string,
    options?: AxiosRequestConfig
  ) {
    return MemberImportApiFp(this.configuration)
      .userApiV1MemberImportTypeGet(
        importType,
        accountNumber,
        memberId,
        memberBarcode,
        groupId,
        tenantId,
        acceptLanguage,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * RequestContextApi - axios parameter creator
 * @export
 */
export const RequestContextApiAxiosParamCreator = function (
  configuration?: Configuration
) {
  return {
    /**
     *
     * @summary
     * @param {string} [tenantId]
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiRequestContextGet: async (
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/UserApi/RequestContext`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "Authorization",
        configuration
      );

      if (tenantId !== undefined) {
        localVarQueryParameter["tenantId"] = tenantId;
      }

      if (apiVersion !== undefined) {
        localVarQueryParameter["api-version"] = apiVersion;
      }

      if (acceptLanguage != null) {
        localVarHeaderParameter["Accept-Language"] = String(acceptLanguage);
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary
     * @param {string} [tenantId]
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiV1RequestContextGet: async (
      tenantId?: string,
      acceptLanguage?: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/UserApi/v1/RequestContext`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "Authorization",
        configuration
      );

      if (tenantId !== undefined) {
        localVarQueryParameter["tenantId"] = tenantId;
      }

      if (acceptLanguage != null) {
        localVarHeaderParameter["Accept-Language"] = String(acceptLanguage);
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * RequestContextApi - functional programming interface
 * @export
 */
export const RequestContextApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator =
    RequestContextApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @summary
     * @param {string} [tenantId]
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async userApiRequestContextGet(
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<IIRadianseRequestContext>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.userApiRequestContextGet(
          tenantId,
          apiVersion,
          acceptLanguage,
          options
        );
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap["RequestContextApi.userApiRequestContextGet"]?.[
          index
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, operationBasePath || basePath);
    },
    /**
     *
     * @summary
     * @param {string} [tenantId]
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async userApiV1RequestContextGet(
      tenantId?: string,
      acceptLanguage?: string,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<IIRadianseRequestContext>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.userApiV1RequestContextGet(
          tenantId,
          acceptLanguage,
          options
        );
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap["RequestContextApi.userApiV1RequestContextGet"]?.[
          index
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, operationBasePath || basePath);
    },
  };
};

/**
 * RequestContextApi - factory interface
 * @export
 */
export const RequestContextApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = RequestContextApiFp(configuration);
  return {
    /**
     *
     * @summary
     * @param {string} [tenantId]
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiRequestContextGet(
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options?: any
    ): AxiosPromise<IIRadianseRequestContext> {
      return localVarFp
        .userApiRequestContextGet(tenantId, apiVersion, acceptLanguage, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary
     * @param {string} [tenantId]
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiV1RequestContextGet(
      tenantId?: string,
      acceptLanguage?: string,
      options?: any
    ): AxiosPromise<IIRadianseRequestContext> {
      return localVarFp
        .userApiV1RequestContextGet(tenantId, acceptLanguage, options)
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * RequestContextApi - object-oriented interface
 * @export
 * @class RequestContextApi
 * @extends {BaseAPI}
 */
export class RequestContextApi extends BaseAPI {
  /**
   *
   * @summary
   * @param {string} [tenantId]
   * @param {string} [apiVersion] The requested API version
   * @param {string} [acceptLanguage]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof RequestContextApi
   */
  public userApiRequestContextGet(
    tenantId?: string,
    apiVersion?: string,
    acceptLanguage?: string,
    options?: AxiosRequestConfig
  ) {
    return RequestContextApiFp(this.configuration)
      .userApiRequestContextGet(tenantId, apiVersion, acceptLanguage, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary
   * @param {string} [tenantId]
   * @param {string} [acceptLanguage]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof RequestContextApi
   */
  public userApiV1RequestContextGet(
    tenantId?: string,
    acceptLanguage?: string,
    options?: AxiosRequestConfig
  ) {
    return RequestContextApiFp(this.configuration)
      .userApiV1RequestContextGet(tenantId, acceptLanguage, options)
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * TenantImportApi - axios parameter creator
 * @export
 */
export const TenantImportApiAxiosParamCreator = function (
  configuration?: Configuration
) {
  return {
    /**
     * Permission: tenantimport_read
     * @summary Import members from tenant
     * @param {IImportType} importType
     * @param {string} [accountNumber] If account number is not known, attempts to find account number from tenantId
     * @param {string} [lastModified] Start at date member was last modified. Default to 100 years prior
     * @param {string} [groupId] If using a group token, include groupId
     * @param {string} [tenantId] If using a tenant token, include tenantId
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiTenantImportTypeGet: async (
      importType: IImportType,
      accountNumber?: string,
      lastModified?: string,
      groupId?: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'importType' is not null or undefined
      assertParamExists("userApiTenantImportTypeGet", "importType", importType);
      const localVarPath = `/UserApi/Tenant/{importType}`.replace(
        `{${"importType"}}`,
        encodeURIComponent(String(importType))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "Authorization",
        configuration
      );

      if (accountNumber !== undefined) {
        localVarQueryParameter["accountNumber"] = accountNumber;
      }

      if (lastModified !== undefined) {
        localVarQueryParameter["lastModified"] =
          (lastModified as any) instanceof Date
            ? (lastModified as any).toISOString()
            : lastModified;
      }

      if (groupId !== undefined) {
        localVarQueryParameter["groupId"] = groupId;
      }

      if (tenantId !== undefined) {
        localVarQueryParameter["tenantId"] = tenantId;
      }

      if (apiVersion !== undefined) {
        localVarQueryParameter["api-version"] = apiVersion;
      }

      if (acceptLanguage != null) {
        localVarHeaderParameter["Accept-Language"] = String(acceptLanguage);
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Permission: tenantimport_read
     * @summary Import member photos from tenant
     * @param {IImportType} importType
     * @param {string} [accountNumber] If account number is not known, attempts to find account number from tenantId
     * @param {string} [groupId] If using a group token, include groupId
     * @param {string} [tenantId] If using a tenant token, include tenantId
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiTenantPhotosImportTypeGet: async (
      importType: IImportType,
      accountNumber?: string,
      groupId?: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'importType' is not null or undefined
      assertParamExists(
        "userApiTenantPhotosImportTypeGet",
        "importType",
        importType
      );
      const localVarPath = `/UserApi/Tenant/Photos/{importType}`.replace(
        `{${"importType"}}`,
        encodeURIComponent(String(importType))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "Authorization",
        configuration
      );

      if (accountNumber !== undefined) {
        localVarQueryParameter["accountNumber"] = accountNumber;
      }

      if (groupId !== undefined) {
        localVarQueryParameter["groupId"] = groupId;
      }

      if (tenantId !== undefined) {
        localVarQueryParameter["tenantId"] = tenantId;
      }

      if (apiVersion !== undefined) {
        localVarQueryParameter["api-version"] = apiVersion;
      }

      if (acceptLanguage != null) {
        localVarHeaderParameter["Accept-Language"] = String(acceptLanguage);
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * For ABC, these are in the /membershiptypes
     * @summary Import service access types
     * @param {IImportType} importType
     * @param {string} [groupId]
     * @param {string} [tenantId]
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiTenantServiceAccessTypeImportTypeGet: async (
      importType: IImportType,
      groupId?: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'importType' is not null or undefined
      assertParamExists(
        "userApiTenantServiceAccessTypeImportTypeGet",
        "importType",
        importType
      );
      const localVarPath =
        `/UserApi/Tenant/ServiceAccessType/{importType}`.replace(
          `{${"importType"}}`,
          encodeURIComponent(String(importType))
        );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "Authorization",
        configuration
      );

      if (groupId !== undefined) {
        localVarQueryParameter["groupId"] = groupId;
      }

      if (tenantId !== undefined) {
        localVarQueryParameter["tenantId"] = tenantId;
      }

      if (apiVersion !== undefined) {
        localVarQueryParameter["api-version"] = apiVersion;
      }

      if (acceptLanguage != null) {
        localVarHeaderParameter["Accept-Language"] = String(acceptLanguage);
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Permission: tenantimport_read
     * @summary Import members from tenant
     * @param {IImportType} importType
     * @param {string} [accountNumber] If account number is not known, attempts to find account number from tenantId
     * @param {string} [lastModified] Start at date member was last modified. Default to 100 years prior
     * @param {string} [groupId] If using a group token, include groupId
     * @param {string} [tenantId] If using a tenant token, include tenantId
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiV1TenantImportTypeGet: async (
      importType: IImportType,
      accountNumber?: string,
      lastModified?: string,
      groupId?: string,
      tenantId?: string,
      acceptLanguage?: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'importType' is not null or undefined
      assertParamExists(
        "userApiV1TenantImportTypeGet",
        "importType",
        importType
      );
      const localVarPath = `/UserApi/v1/Tenant/{importType}`.replace(
        `{${"importType"}}`,
        encodeURIComponent(String(importType))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "Authorization",
        configuration
      );

      if (accountNumber !== undefined) {
        localVarQueryParameter["accountNumber"] = accountNumber;
      }

      if (lastModified !== undefined) {
        localVarQueryParameter["lastModified"] =
          (lastModified as any) instanceof Date
            ? (lastModified as any).toISOString()
            : lastModified;
      }

      if (groupId !== undefined) {
        localVarQueryParameter["groupId"] = groupId;
      }

      if (tenantId !== undefined) {
        localVarQueryParameter["tenantId"] = tenantId;
      }

      if (acceptLanguage != null) {
        localVarHeaderParameter["Accept-Language"] = String(acceptLanguage);
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Permission: tenantimport_read
     * @summary Import member photos from tenant
     * @param {IImportType} importType
     * @param {string} [accountNumber] If account number is not known, attempts to find account number from tenantId
     * @param {string} [groupId] If using a group token, include groupId
     * @param {string} [tenantId] If using a tenant token, include tenantId
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiV1TenantPhotosImportTypeGet: async (
      importType: IImportType,
      accountNumber?: string,
      groupId?: string,
      tenantId?: string,
      acceptLanguage?: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'importType' is not null or undefined
      assertParamExists(
        "userApiV1TenantPhotosImportTypeGet",
        "importType",
        importType
      );
      const localVarPath = `/UserApi/v1/Tenant/Photos/{importType}`.replace(
        `{${"importType"}}`,
        encodeURIComponent(String(importType))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "Authorization",
        configuration
      );

      if (accountNumber !== undefined) {
        localVarQueryParameter["accountNumber"] = accountNumber;
      }

      if (groupId !== undefined) {
        localVarQueryParameter["groupId"] = groupId;
      }

      if (tenantId !== undefined) {
        localVarQueryParameter["tenantId"] = tenantId;
      }

      if (acceptLanguage != null) {
        localVarHeaderParameter["Accept-Language"] = String(acceptLanguage);
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * For ABC, these are in the /membershiptypes
     * @summary Import service access types
     * @param {IImportType} importType
     * @param {string} [groupId]
     * @param {string} [tenantId]
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiV1TenantServiceAccessTypeImportTypeGet: async (
      importType: IImportType,
      groupId?: string,
      tenantId?: string,
      acceptLanguage?: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'importType' is not null or undefined
      assertParamExists(
        "userApiV1TenantServiceAccessTypeImportTypeGet",
        "importType",
        importType
      );
      const localVarPath =
        `/UserApi/v1/Tenant/ServiceAccessType/{importType}`.replace(
          `{${"importType"}}`,
          encodeURIComponent(String(importType))
        );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "Authorization",
        configuration
      );

      if (groupId !== undefined) {
        localVarQueryParameter["groupId"] = groupId;
      }

      if (tenantId !== undefined) {
        localVarQueryParameter["tenantId"] = tenantId;
      }

      if (acceptLanguage != null) {
        localVarHeaderParameter["Accept-Language"] = String(acceptLanguage);
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * TenantImportApi - functional programming interface
 * @export
 */
export const TenantImportApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator =
    TenantImportApiAxiosParamCreator(configuration);
  return {
    /**
     * Permission: tenantimport_read
     * @summary Import members from tenant
     * @param {IImportType} importType
     * @param {string} [accountNumber] If account number is not known, attempts to find account number from tenantId
     * @param {string} [lastModified] Start at date member was last modified. Default to 100 years prior
     * @param {string} [groupId] If using a group token, include groupId
     * @param {string} [tenantId] If using a tenant token, include tenantId
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async userApiTenantImportTypeGet(
      importType: IImportType,
      accountNumber?: string,
      lastModified?: string,
      groupId?: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<IMemberUpdateReturnIRadianseResultSuccess>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.userApiTenantImportTypeGet(
          importType,
          accountNumber,
          lastModified,
          groupId,
          tenantId,
          apiVersion,
          acceptLanguage,
          options
        );
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap["TenantImportApi.userApiTenantImportTypeGet"]?.[
          index
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, operationBasePath || basePath);
    },
    /**
     * Permission: tenantimport_read
     * @summary Import member photos from tenant
     * @param {IImportType} importType
     * @param {string} [accountNumber] If account number is not known, attempts to find account number from tenantId
     * @param {string} [groupId] If using a group token, include groupId
     * @param {string} [tenantId] If using a tenant token, include tenantId
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async userApiTenantPhotosImportTypeGet(
      importType: IImportType,
      accountNumber?: string,
      groupId?: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<IMemberUpdateReturnIRadianseResultSuccess>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.userApiTenantPhotosImportTypeGet(
          importType,
          accountNumber,
          groupId,
          tenantId,
          apiVersion,
          acceptLanguage,
          options
        );
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap[
          "TenantImportApi.userApiTenantPhotosImportTypeGet"
        ]?.[index]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, operationBasePath || basePath);
    },
    /**
     * For ABC, these are in the /membershiptypes
     * @summary Import service access types
     * @param {IImportType} importType
     * @param {string} [groupId]
     * @param {string} [tenantId]
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async userApiTenantServiceAccessTypeImportTypeGet(
      importType: IImportType,
      groupId?: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<IMemberUpdateReturnIRadianseResultSuccess>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.userApiTenantServiceAccessTypeImportTypeGet(
          importType,
          groupId,
          tenantId,
          apiVersion,
          acceptLanguage,
          options
        );
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap[
          "TenantImportApi.userApiTenantServiceAccessTypeImportTypeGet"
        ]?.[index]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, operationBasePath || basePath);
    },
    /**
     * Permission: tenantimport_read
     * @summary Import members from tenant
     * @param {IImportType} importType
     * @param {string} [accountNumber] If account number is not known, attempts to find account number from tenantId
     * @param {string} [lastModified] Start at date member was last modified. Default to 100 years prior
     * @param {string} [groupId] If using a group token, include groupId
     * @param {string} [tenantId] If using a tenant token, include tenantId
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async userApiV1TenantImportTypeGet(
      importType: IImportType,
      accountNumber?: string,
      lastModified?: string,
      groupId?: string,
      tenantId?: string,
      acceptLanguage?: string,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<IMemberUpdateReturnIRadianseResultSuccess>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.userApiV1TenantImportTypeGet(
          importType,
          accountNumber,
          lastModified,
          groupId,
          tenantId,
          acceptLanguage,
          options
        );
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap["TenantImportApi.userApiV1TenantImportTypeGet"]?.[
          index
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, operationBasePath || basePath);
    },
    /**
     * Permission: tenantimport_read
     * @summary Import member photos from tenant
     * @param {IImportType} importType
     * @param {string} [accountNumber] If account number is not known, attempts to find account number from tenantId
     * @param {string} [groupId] If using a group token, include groupId
     * @param {string} [tenantId] If using a tenant token, include tenantId
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async userApiV1TenantPhotosImportTypeGet(
      importType: IImportType,
      accountNumber?: string,
      groupId?: string,
      tenantId?: string,
      acceptLanguage?: string,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<IMemberUpdateReturnIRadianseResultSuccess>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.userApiV1TenantPhotosImportTypeGet(
          importType,
          accountNumber,
          groupId,
          tenantId,
          acceptLanguage,
          options
        );
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap[
          "TenantImportApi.userApiV1TenantPhotosImportTypeGet"
        ]?.[index]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, operationBasePath || basePath);
    },
    /**
     * For ABC, these are in the /membershiptypes
     * @summary Import service access types
     * @param {IImportType} importType
     * @param {string} [groupId]
     * @param {string} [tenantId]
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async userApiV1TenantServiceAccessTypeImportTypeGet(
      importType: IImportType,
      groupId?: string,
      tenantId?: string,
      acceptLanguage?: string,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<IMemberUpdateReturnIRadianseResultSuccess>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.userApiV1TenantServiceAccessTypeImportTypeGet(
          importType,
          groupId,
          tenantId,
          acceptLanguage,
          options
        );
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap[
          "TenantImportApi.userApiV1TenantServiceAccessTypeImportTypeGet"
        ]?.[index]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, operationBasePath || basePath);
    },
  };
};

/**
 * TenantImportApi - factory interface
 * @export
 */
export const TenantImportApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = TenantImportApiFp(configuration);
  return {
    /**
     * Permission: tenantimport_read
     * @summary Import members from tenant
     * @param {IImportType} importType
     * @param {string} [accountNumber] If account number is not known, attempts to find account number from tenantId
     * @param {string} [lastModified] Start at date member was last modified. Default to 100 years prior
     * @param {string} [groupId] If using a group token, include groupId
     * @param {string} [tenantId] If using a tenant token, include tenantId
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiTenantImportTypeGet(
      importType: IImportType,
      accountNumber?: string,
      lastModified?: string,
      groupId?: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options?: any
    ): AxiosPromise<IMemberUpdateReturnIRadianseResultSuccess> {
      return localVarFp
        .userApiTenantImportTypeGet(
          importType,
          accountNumber,
          lastModified,
          groupId,
          tenantId,
          apiVersion,
          acceptLanguage,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     * Permission: tenantimport_read
     * @summary Import member photos from tenant
     * @param {IImportType} importType
     * @param {string} [accountNumber] If account number is not known, attempts to find account number from tenantId
     * @param {string} [groupId] If using a group token, include groupId
     * @param {string} [tenantId] If using a tenant token, include tenantId
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiTenantPhotosImportTypeGet(
      importType: IImportType,
      accountNumber?: string,
      groupId?: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options?: any
    ): AxiosPromise<IMemberUpdateReturnIRadianseResultSuccess> {
      return localVarFp
        .userApiTenantPhotosImportTypeGet(
          importType,
          accountNumber,
          groupId,
          tenantId,
          apiVersion,
          acceptLanguage,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     * For ABC, these are in the /membershiptypes
     * @summary Import service access types
     * @param {IImportType} importType
     * @param {string} [groupId]
     * @param {string} [tenantId]
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiTenantServiceAccessTypeImportTypeGet(
      importType: IImportType,
      groupId?: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options?: any
    ): AxiosPromise<IMemberUpdateReturnIRadianseResultSuccess> {
      return localVarFp
        .userApiTenantServiceAccessTypeImportTypeGet(
          importType,
          groupId,
          tenantId,
          apiVersion,
          acceptLanguage,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     * Permission: tenantimport_read
     * @summary Import members from tenant
     * @param {IImportType} importType
     * @param {string} [accountNumber] If account number is not known, attempts to find account number from tenantId
     * @param {string} [lastModified] Start at date member was last modified. Default to 100 years prior
     * @param {string} [groupId] If using a group token, include groupId
     * @param {string} [tenantId] If using a tenant token, include tenantId
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiV1TenantImportTypeGet(
      importType: IImportType,
      accountNumber?: string,
      lastModified?: string,
      groupId?: string,
      tenantId?: string,
      acceptLanguage?: string,
      options?: any
    ): AxiosPromise<IMemberUpdateReturnIRadianseResultSuccess> {
      return localVarFp
        .userApiV1TenantImportTypeGet(
          importType,
          accountNumber,
          lastModified,
          groupId,
          tenantId,
          acceptLanguage,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     * Permission: tenantimport_read
     * @summary Import member photos from tenant
     * @param {IImportType} importType
     * @param {string} [accountNumber] If account number is not known, attempts to find account number from tenantId
     * @param {string} [groupId] If using a group token, include groupId
     * @param {string} [tenantId] If using a tenant token, include tenantId
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiV1TenantPhotosImportTypeGet(
      importType: IImportType,
      accountNumber?: string,
      groupId?: string,
      tenantId?: string,
      acceptLanguage?: string,
      options?: any
    ): AxiosPromise<IMemberUpdateReturnIRadianseResultSuccess> {
      return localVarFp
        .userApiV1TenantPhotosImportTypeGet(
          importType,
          accountNumber,
          groupId,
          tenantId,
          acceptLanguage,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     * For ABC, these are in the /membershiptypes
     * @summary Import service access types
     * @param {IImportType} importType
     * @param {string} [groupId]
     * @param {string} [tenantId]
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiV1TenantServiceAccessTypeImportTypeGet(
      importType: IImportType,
      groupId?: string,
      tenantId?: string,
      acceptLanguage?: string,
      options?: any
    ): AxiosPromise<IMemberUpdateReturnIRadianseResultSuccess> {
      return localVarFp
        .userApiV1TenantServiceAccessTypeImportTypeGet(
          importType,
          groupId,
          tenantId,
          acceptLanguage,
          options
        )
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * TenantImportApi - object-oriented interface
 * @export
 * @class TenantImportApi
 * @extends {BaseAPI}
 */
export class TenantImportApi extends BaseAPI {
  /**
   * Permission: tenantimport_read
   * @summary Import members from tenant
   * @param {IImportType} importType
   * @param {string} [accountNumber] If account number is not known, attempts to find account number from tenantId
   * @param {string} [lastModified] Start at date member was last modified. Default to 100 years prior
   * @param {string} [groupId] If using a group token, include groupId
   * @param {string} [tenantId] If using a tenant token, include tenantId
   * @param {string} [apiVersion] The requested API version
   * @param {string} [acceptLanguage]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof TenantImportApi
   */
  public userApiTenantImportTypeGet(
    importType: IImportType,
    accountNumber?: string,
    lastModified?: string,
    groupId?: string,
    tenantId?: string,
    apiVersion?: string,
    acceptLanguage?: string,
    options?: AxiosRequestConfig
  ) {
    return TenantImportApiFp(this.configuration)
      .userApiTenantImportTypeGet(
        importType,
        accountNumber,
        lastModified,
        groupId,
        tenantId,
        apiVersion,
        acceptLanguage,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Permission: tenantimport_read
   * @summary Import member photos from tenant
   * @param {IImportType} importType
   * @param {string} [accountNumber] If account number is not known, attempts to find account number from tenantId
   * @param {string} [groupId] If using a group token, include groupId
   * @param {string} [tenantId] If using a tenant token, include tenantId
   * @param {string} [apiVersion] The requested API version
   * @param {string} [acceptLanguage]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof TenantImportApi
   */
  public userApiTenantPhotosImportTypeGet(
    importType: IImportType,
    accountNumber?: string,
    groupId?: string,
    tenantId?: string,
    apiVersion?: string,
    acceptLanguage?: string,
    options?: AxiosRequestConfig
  ) {
    return TenantImportApiFp(this.configuration)
      .userApiTenantPhotosImportTypeGet(
        importType,
        accountNumber,
        groupId,
        tenantId,
        apiVersion,
        acceptLanguage,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * For ABC, these are in the /membershiptypes
   * @summary Import service access types
   * @param {IImportType} importType
   * @param {string} [groupId]
   * @param {string} [tenantId]
   * @param {string} [apiVersion] The requested API version
   * @param {string} [acceptLanguage]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof TenantImportApi
   */
  public userApiTenantServiceAccessTypeImportTypeGet(
    importType: IImportType,
    groupId?: string,
    tenantId?: string,
    apiVersion?: string,
    acceptLanguage?: string,
    options?: AxiosRequestConfig
  ) {
    return TenantImportApiFp(this.configuration)
      .userApiTenantServiceAccessTypeImportTypeGet(
        importType,
        groupId,
        tenantId,
        apiVersion,
        acceptLanguage,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Permission: tenantimport_read
   * @summary Import members from tenant
   * @param {IImportType} importType
   * @param {string} [accountNumber] If account number is not known, attempts to find account number from tenantId
   * @param {string} [lastModified] Start at date member was last modified. Default to 100 years prior
   * @param {string} [groupId] If using a group token, include groupId
   * @param {string} [tenantId] If using a tenant token, include tenantId
   * @param {string} [acceptLanguage]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof TenantImportApi
   */
  public userApiV1TenantImportTypeGet(
    importType: IImportType,
    accountNumber?: string,
    lastModified?: string,
    groupId?: string,
    tenantId?: string,
    acceptLanguage?: string,
    options?: AxiosRequestConfig
  ) {
    return TenantImportApiFp(this.configuration)
      .userApiV1TenantImportTypeGet(
        importType,
        accountNumber,
        lastModified,
        groupId,
        tenantId,
        acceptLanguage,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Permission: tenantimport_read
   * @summary Import member photos from tenant
   * @param {IImportType} importType
   * @param {string} [accountNumber] If account number is not known, attempts to find account number from tenantId
   * @param {string} [groupId] If using a group token, include groupId
   * @param {string} [tenantId] If using a tenant token, include tenantId
   * @param {string} [acceptLanguage]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof TenantImportApi
   */
  public userApiV1TenantPhotosImportTypeGet(
    importType: IImportType,
    accountNumber?: string,
    groupId?: string,
    tenantId?: string,
    acceptLanguage?: string,
    options?: AxiosRequestConfig
  ) {
    return TenantImportApiFp(this.configuration)
      .userApiV1TenantPhotosImportTypeGet(
        importType,
        accountNumber,
        groupId,
        tenantId,
        acceptLanguage,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * For ABC, these are in the /membershiptypes
   * @summary Import service access types
   * @param {IImportType} importType
   * @param {string} [groupId]
   * @param {string} [tenantId]
   * @param {string} [acceptLanguage]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof TenantImportApi
   */
  public userApiV1TenantServiceAccessTypeImportTypeGet(
    importType: IImportType,
    groupId?: string,
    tenantId?: string,
    acceptLanguage?: string,
    options?: AxiosRequestConfig
  ) {
    return TenantImportApiFp(this.configuration)
      .userApiV1TenantServiceAccessTypeImportTypeGet(
        importType,
        groupId,
        tenantId,
        acceptLanguage,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }
}
